var _defs, _g, _g2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8585",
    "data-name": "Group 8585",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    height: 769,
    viewBox: "0 0 1366 769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3335",
    "data-name": "Rectangle 3335",
    width: 74.226,
    height: 20.097,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3336",
    "data-name": "Rectangle 3336",
    width: 74.497,
    height: 20.17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3337",
    "data-name": "Rectangle 3337",
    width: 34.688,
    height: 11.227,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3342",
    "data-name": "Rectangle 3342",
    width: 182.427,
    height: 18.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3344",
    "data-name": "Rectangle 3344",
    width: 61.073,
    height: 7.003,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3351",
    "data-name": "Rectangle 3351",
    width: 78.568,
    height: 69.653,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3354",
    "data-name": "Rectangle 3354",
    width: 28.008,
    height: 33.121,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4821",
    "data-name": "Group 4821",
    transform: "translate(184 104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3378",
    "data-name": "Rectangle 3378",
    width: 605.582,
    height: 447.376,
    transform: "translate(272.547 58.373)",
    fill: "#7999c6",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3400",
    "data-name": "Rectangle 3400",
    width: 12.782,
    height: 429.97,
    transform: "translate(860.131 72.05)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3944",
    "data-name": "Path 3944",
    d: "M670.458,495.126l-198.879.856c-48.338-37.948-53.332-94.171-18.847-128.25,20.871-20.613,47.374-16.454,72.61-19.734.025,0,.05-.012.073-.012,8.79-1.144,17.412-3.195,25.6-7.51C577,326.77,591.649,294.44,613.509,267.244q4.087-5.117,8.561-9.922c17.979-19.19,53.758-19.815,72.474,7.165,47.553,68.555,25.769,170.59-24.086,230.638",
    transform: "translate(277.388 27.935)",
    fill: "#102c5d",
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_570",
    "data-name": "Line 570",
    x2: 796.53,
    transform: "translate(181.797 525.211)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeWidth: 2,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    d: "M654.868,80.171l-19.069.605-9.678.243c-3.234.1-6.484.08-9.727.119l-.644.007,0-.974-.078-24.284,0-1.089.728.007,19.238.137c6.412.011,12.823.243,19.236.354l.4.006,0,.586c-.027,4.121-.125,8.219-.19,12.27Zm0,0-.206-12.27c-.066-4.043-.162-8.041-.19-12.014l.4.592c-6.413.111-12.825.345-19.236.356l-19.238.137.726-1.085-.078,24.284-.648-.968c3.17.039,6.332.017,9.511.119l9.559.243Z",
    transform: "translate(221.167 -54.797)",
    fill: "#bfc8da",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4048",
    "data-name": "Path 4048",
    d: "M676.74,80.171l-29.708.605-15.077.243c-5.039.1-10.1.08-15.154.119l-1,.007,0-.974-.122-24.284,0-1.089,1.134.007,29.971.137c9.989.011,19.978.243,29.969.354l.624.006-.006.586c-.043,4.121-.195,8.219-.3,12.27Zm0,0-.322-12.27c-.1-4.043-.253-8.041-.3-12.014l.618.592c-9.991.111-19.98.345-29.969.356l-29.971.137,1.131-1.085-.121,24.284L616.8,79.2c4.939.039,9.865.017,14.817.119l14.892.243Z",
    transform: "translate(285.614 -41.623)",
    fill: "#bfc8da",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4325",
    "data-name": "Path 4325",
    d: "M676.74,80.171l-29.708.605-15.077.243c-5.039.1-10.1.08-15.154.119l-1,.007,0-.974-.122-24.284,0-1.089,1.134.007,29.971.137c9.989.011,19.978.243,29.969.354l.624.006-.006.586c-.043,4.121-.195,8.219-.3,12.27Zm0,0-.322-12.27c-.1-4.043-.253-8.041-.3-12.014l.618.592c-9.991.111-19.98.345-29.969.356l-29.971.137,1.131-1.085-.121,24.284L616.8,79.2c4.939.039,9.865.017,14.817.119l14.892.243Z",
    transform: "translate(-615.666 405.456)",
    fill: "#bfc8da",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3390",
    "data-name": "Rectangle 3390",
    width: 8.803,
    height: 29.096,
    transform: "translate(808.964 172.995)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3391",
    "data-name": "Rectangle 3391",
    width: 8.803,
    height: 8.993,
    transform: "translate(808.964 172.988)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4004",
    "data-name": "Path 4004",
    d: "M548.91,117.831c1.7.122,2.658,2.876,3.95,3.718a1.273,1.273,0,0,0,1.885-.224c1.381-1.779-.333-4.106-1.976-5.433,1.191.543,2.161,1.456,3.456,1.753a1.227,1.227,0,0,0,1.625-.89c.671-2.474-2.418-3.7-4.562-3.836,1.068-.684,4.127-2.537,2.579-3.564-1.57-1.032-5.178,1.647-6.355,2.529-1.731,1.3-3.81,3.256-3.966,5.383-.194,2.483,2.039,1.035,3.365.564",
    transform: "translate(313.691 -11.505)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    d: "M548.434,117.689c2.209-.9,6.325.675,6.712-.133.783-1.645-2.507-2.92-4.3-3.21,1.674-.385,4.876-.978,4.838-2.58-.045-1.956-4.858-.459-7.332,1.293-3.117,2.207-3.183,4.448-2.7,4.916.664.642,2.415-.137,2.779-.285",
    transform: "translate(313.661 -10.956)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3384",
    "data-name": "Rectangle 3384",
    width: 601.632,
    height: 17.539,
    transform: "translate(271.282 48.584)",
    fill: "#e6eaec",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3743",
    "data-name": "Path 3743",
    d: "M128.754,79.677a3.1,3.1,0,1,1-3.1-3.1,3.1,3.1,0,0,1,3.1,3.1",
    transform: "translate(193.28 -22.288)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    "data-name": "Path 4006",
    d: "M551.865,236.922h0a3.3,3.3,0,0,1-3.3-3.3V90.853a3.3,3.3,0,0,1,6.6,0V233.621a3.3,3.3,0,0,1-3.3,3.3",
    transform: "translate(314.649 -18.093)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3385",
    "data-name": "Rectangle 3385",
    width: 588.849,
    height: 114.753,
    transform: "translate(271.363 65.955)",
    fill: "#ebebeb",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3852",
    "data-name": "Path 3852",
    d: "M494.21,112.642a18.416,18.416,0,1,0,14.458-14.453,18.43,18.43,0,0,0-14.458,14.453",
    transform: "translate(307.347 -15.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3386",
    "data-name": "Rectangle 3386",
    width: 588.849,
    height: 19.394,
    transform: "translate(270.682 160.339)",
    fill: "#dbdbdb",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3744",
    "data-name": "Path 3744",
    d: "M582.652,170.744,493.17,118.021l-81.334,41.9L361.092,141l-76.67,29.747Z",
    transform: "translate(236.207 -10.154)",
    fill: "#dbdbdb",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4459",
    "data-name": "Group 4459",
    transform: "translate(638.769 79.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4376",
    "data-name": "Group 4376",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M447.687,115.534H373.461s7.359-20.1,18.685-20.1,14.875,13.872,14.875,13.872,7.642-7.537,13.919-7.537,11.735,9.96,11.735,9.96,8.87-5.355,15.011,3.8",
    transform: "translate(-373.461 -95.437)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4455",
    "data-name": "Group 4455",
    transform: "translate(458.207 119.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4379",
    "data-name": "Group 4379",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M307.864,147.346h-74.5s7.388-20.17,18.755-20.17S267.05,141.1,267.05,141.1s7.669-7.563,13.969-7.563,11.779,10,11.779,10,8.9-5.375,15.066,3.816",
    transform: "translate(-233.367 -127.176)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4456",
    "data-name": "Group 4456",
    transform: "translate(455.131 95.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4382",
    "data-name": "Group 4382",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M265.371,118.794H230.683s7.751-11.227,13.857-11.227,7.911,7.484,7.911,7.484,4.309-3.492,8.3-2.868,4.617,6.611,4.617,6.611",
    transform: "translate(-230.683 -107.567)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3853",
    "data-name": "Path 3853",
    d: "M370.93,123.469H336.242s7.751-11.227,13.857-11.227,7.912,7.485,7.912,7.485,4.309-3.492,8.3-2.868,4.616,6.611,4.616,6.611",
    transform: "translate(255.051 -10.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3387",
    "data-name": "Rectangle 3387",
    width: 182.427,
    height: 323.537,
    transform: "translate(283.144 178.483)",
    fill: "#0d2d66",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3388",
    "data-name": "Rectangle 3388",
    width: 124.366,
    height: 124.335,
    transform: "translate(312.576 88.369)",
    fill: "#667ca3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3389",
    "data-name": "Rectangle 3389",
    width: 113.231,
    height: 113.202,
    transform: "translate(318.111 93.898)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4460",
    "data-name": "Group 4460",
    transform: "translate(283.144 340.652)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4385",
    "data-name": "Group 4385",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3341",
    "data-name": "Rectangle 3341",
    width: 182.427,
    height: 18.805
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3745",
    "data-name": "Path 3745",
    d: "M121.8,217.11V208.6a.791.791,0,0,1,.795-.793.8.8,0,0,1,.808.793V216.3h3.911a.8.8,0,0,1,0,1.6h-4.719a.792.792,0,0,1-.795-.794",
    transform: "translate(193.059 17.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3746",
    "data-name": "Path 3746",
    d: "M128.49,216.159a3.6,3.6,0,0,1-1-2.54,3.722,3.722,0,0,1,1-2.525,3.37,3.37,0,0,1,2.482-1.1,3.188,3.188,0,0,1,2.41,1.1,3.6,3.6,0,0,1,1.01,2.525,3.491,3.491,0,0,1-1.01,2.54,3.188,3.188,0,0,1-2.41,1.1,3.37,3.37,0,0,1-2.482-1.1m.578-2.54a2.334,2.334,0,0,0,.52,1.529,1.954,1.954,0,0,0,1.385.534,1.9,1.9,0,0,0,1.329-.534,2.217,2.217,0,0,0,.562-1.529,2.169,2.169,0,0,0-.562-1.5,2.046,2.046,0,0,0-1.329-.548,2.1,2.1,0,0,0-1.385.548,2.283,2.283,0,0,0-.52,1.5",
    transform: "translate(194.712 18.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3747",
    "data-name": "Path 3747",
    d: "M138.832,210.76a.769.769,0,0,1-.766.764,1.386,1.386,0,0,0-.866.275,2.186,2.186,0,0,0-.664.693,4.436,4.436,0,0,0-.591,1.211v2.742a.786.786,0,0,1-.795.764.769.769,0,0,1-.764-.764V210.76a.757.757,0,0,1,.764-.75.774.774,0,0,1,.795.75v.1a1.947,1.947,0,0,1,.3-.289,3.169,3.169,0,0,1,1.818-.562.749.749,0,0,1,.766.75",
    transform: "translate(196.731 18.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    d: "M138.272,213.606A3.573,3.573,0,0,1,141.793,210a3.451,3.451,0,0,1,3.479,3.347v.072a.4.4,0,0,1-.014.13.7.7,0,0,1-.751.577h-4.59a1.9,1.9,0,0,0,.491.952,2.233,2.233,0,0,0,1.385.648,2.362,2.362,0,0,0,1.5-.36.817.817,0,0,1,1.083-.043.658.658,0,0,1,0,.938,3.643,3.643,0,0,1-2.584.952,3.581,3.581,0,0,1-3.522-3.606m1.575-.708h4.085a2.361,2.361,0,0,0-2.138-1.53,2.017,2.017,0,0,0-1.947,1.53",
    transform: "translate(197.843 18.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    d: "M151.359,213v3.448a.759.759,0,0,1-.75.765.78.78,0,0,1-.766-.765V213a1.481,1.481,0,0,0-1.5-1.457A1.442,1.442,0,0,0,146.9,213v3.448a.286.286,0,0,1-.029.145.79.79,0,0,1-.766.621.761.761,0,0,1-.764-.765v-5.685a.76.76,0,0,1,.764-.764.782.782,0,0,1,.708.447,2.885,2.885,0,0,1,1.53-.447,3.02,3.02,0,0,1,3.016,3",
    transform: "translate(199.905 18.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750",
    "data-name": "Path 3750",
    d: "M155.142,212.779a5.3,5.3,0,0,1,5.3-5.195,5.405,5.405,0,0,1,3.335,1.126.829.829,0,0,1-1.01,1.314,3.6,3.6,0,0,0-2.324-.794,3.817,3.817,0,0,0-2.6,1.039,3.558,3.558,0,0,0-1.054,2.511,3.507,3.507,0,0,0,1.054,2.511,3.817,3.817,0,0,0,2.6,1.039,3.63,3.63,0,0,0,2.324-.793.874.874,0,0,1,1.154.158.851.851,0,0,1-.143,1.155,5.406,5.406,0,0,1-3.335,1.126,5.278,5.278,0,0,1-5.3-5.195",
    transform: "translate(202.733 17.657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751",
    "data-name": "Path 3751",
    d: "M164.457,216.159a3.6,3.6,0,0,1-1-2.54,3.722,3.722,0,0,1,1-2.525,3.37,3.37,0,0,1,2.482-1.1,3.188,3.188,0,0,1,2.41,1.1,3.6,3.6,0,0,1,1.01,2.525,3.491,3.491,0,0,1-1.01,2.54,3.188,3.188,0,0,1-2.41,1.1,3.37,3.37,0,0,1-2.482-1.1m.577-2.54a2.334,2.334,0,0,0,.52,1.529,1.953,1.953,0,0,0,1.385.534,1.9,1.9,0,0,0,1.329-.534,2.216,2.216,0,0,0,.562-1.529,2.169,2.169,0,0,0-.562-1.5,2.046,2.046,0,0,0-1.329-.548,2.1,2.1,0,0,0-1.385.548,2.282,2.282,0,0,0-.52,1.5",
    transform: "translate(205.165 18.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752",
    "data-name": "Path 3752",
    d: "M171.317,216.159a3.6,3.6,0,0,1-1-2.54,3.722,3.722,0,0,1,1-2.525A3.37,3.37,0,0,1,173.8,210a3.19,3.19,0,0,1,2.41,1.1,3.6,3.6,0,0,1,1.01,2.525,3.491,3.491,0,0,1-1.01,2.54,3.19,3.19,0,0,1-2.41,1.1,3.37,3.37,0,0,1-2.482-1.1m.577-2.54a2.334,2.334,0,0,0,.52,1.529,1.953,1.953,0,0,0,1.385.534,1.89,1.89,0,0,0,1.327-.534,2.211,2.211,0,0,0,.563-1.529,2.164,2.164,0,0,0-.563-1.5,2.039,2.039,0,0,0-1.327-.548,2.1,2.1,0,0,0-1.385.548,2.282,2.282,0,0,0-.52,1.5",
    transform: "translate(207.159 18.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    d: "M177.433,219.146v-8.383A.771.771,0,0,1,178.2,210a.793.793,0,0,1,.794.592,3.668,3.668,0,0,1,1.963-.592,3.581,3.581,0,0,1,3.493,3.622,3.542,3.542,0,0,1-3.493,3.578,3.342,3.342,0,0,1-1.934-.592v2.54a.814.814,0,0,1-.823.779.792.792,0,0,1-.764-.779m1.588-5.526a1.923,1.923,0,0,0,.563,1.443,1.786,1.786,0,0,0,1.371.606,1.846,1.846,0,0,0,1.356-.606,2.1,2.1,0,0,0,.563-1.443,2.22,2.22,0,0,0-.563-1.457,1.885,1.885,0,0,0-1.356-.592,1.823,1.823,0,0,0-1.371.592,2.026,2.026,0,0,0-.563,1.457",
    transform: "translate(209.224 18.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    d: "M184.183,213.606A3.572,3.572,0,0,1,187.7,210a3.451,3.451,0,0,1,3.478,3.347v.072a.4.4,0,0,1-.014.13.7.7,0,0,1-.75.577h-4.59a1.893,1.893,0,0,0,.491.952,2.233,2.233,0,0,0,1.385.648,2.362,2.362,0,0,0,1.5-.36.817.817,0,0,1,1.083-.043.659.659,0,0,1,0,.938,3.647,3.647,0,0,1-2.584.952,3.58,3.58,0,0,1-3.521-3.606m1.573-.708h4.085a2.361,2.361,0,0,0-2.136-1.53,2.017,2.017,0,0,0-1.948,1.53",
    transform: "translate(211.184 18.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M195.466,210.76a.769.769,0,0,1-.766.764,1.386,1.386,0,0,0-.866.275,2.187,2.187,0,0,0-.664.693,4.444,4.444,0,0,0-.591,1.211v2.742a.785.785,0,0,1-.795.764.769.769,0,0,1-.764-.764V210.76a.757.757,0,0,1,.764-.75.773.773,0,0,1,.795.75v.1a1.953,1.953,0,0,1,.3-.289,3.169,3.169,0,0,1,1.818-.562.749.749,0,0,1,.766.75",
    transform: "translate(213.192 18.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4458",
    "data-name": "Group 4458",
    transform: "translate(313.446 241.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4388",
    "data-name": "Group 4388",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M126.489,222.616a2.668,2.668,0,0,1-.308,1.27v.008a2.8,2.8,0,0,1-.2.276,1.3,1.3,0,0,1-.616.377.91.91,0,0,1-.205.024.76.76,0,0,1-.726-.529,1.525,1.525,0,0,1-.71.174,1.486,1.486,0,0,1-1.088-.472,1.657,1.657,0,0,1-.434-1.128,1.629,1.629,0,0,1,.434-1.111,1.491,1.491,0,0,1,1.088-.483,1.507,1.507,0,0,1,1.1.483,1.629,1.629,0,0,1,.434,1.111v1.034c.016-.016.032-.025.055-.049a.79.79,0,0,0,.1-.125,1.917,1.917,0,0,0,.2-.86,1.882,1.882,0,1,0-1.886,1.885,2.289,2.289,0,0,0,.474-.047.432.432,0,0,1,.529.308.444.444,0,0,1-.316.537,2.818,2.818,0,0,1-.687.087,2.76,2.76,0,1,1,2.762-2.768m-2.107,0a.786.786,0,0,0-.2-.521.657.657,0,0,0-.458-.2.64.64,0,0,0-.449.2.8.8,0,0,0,0,1.049.609.609,0,0,0,.449.2.625.625,0,0,0,.458-.2.791.791,0,0,0,.2-.529",
    transform: "translate(-120.975 -219.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M127.571,219.863a.439.439,0,0,1,.441.434v4.653a.437.437,0,0,1-.875,0V220.3a.438.438,0,0,1,.434-.434",
    transform: "translate(-119.031 -219.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M128.994,224.43a1.963,1.963,0,0,1-.543-1.387,2.029,2.029,0,0,1,.543-1.38,1.843,1.843,0,0,1,1.356-.6,1.746,1.746,0,0,1,1.318.6,1.966,1.966,0,0,1,.553,1.38,1.9,1.9,0,0,1-.553,1.387,1.745,1.745,0,0,1-1.318.6,1.843,1.843,0,0,1-1.356-.6m.316-1.387a1.276,1.276,0,0,0,.284.836,1.066,1.066,0,0,0,.756.291,1.032,1.032,0,0,0,.726-.291,1.212,1.212,0,0,0,.308-.836,1.186,1.186,0,0,0-.308-.821,1.122,1.122,0,0,0-.726-.3,1.154,1.154,0,0,0-.756.3,1.247,1.247,0,0,0-.284.821",
    transform: "translate(-118.617 -219.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M134.649,221.478a.421.421,0,0,1-.418.418.754.754,0,0,0-.474.15,1.189,1.189,0,0,0-.363.379,2.41,2.41,0,0,0-.322.663v1.5a.43.43,0,0,1-.434.418.421.421,0,0,1-.418-.418v-3.108a.414.414,0,0,1,.418-.41.423.423,0,0,1,.434.41v.055a.97.97,0,0,1,.165-.158,1.731,1.731,0,0,1,.994-.308.409.409,0,0,1,.418.41",
    transform: "translate(-117.428 -219.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M134.342,223.035a1.955,1.955,0,0,1,1.926-1.973,1.887,1.887,0,0,1,1.9,1.831v.04a.218.218,0,0,1-.008.071.381.381,0,0,1-.41.316h-2.509a1.03,1.03,0,0,0,.268.519,1.221,1.221,0,0,0,.758.355,1.288,1.288,0,0,0,.82-.2.449.449,0,0,1,.592-.024.36.36,0,0,1,0,.513,1.994,1.994,0,0,1-1.412.521,1.959,1.959,0,0,1-1.926-1.972m.86-.387h2.232a1.289,1.289,0,0,0-1.167-.836,1.1,1.1,0,0,0-1.065.836",
    transform: "translate(-116.758 -219.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M141.5,222.7v1.885a.414.414,0,0,1-.411.418.425.425,0,0,1-.417-.418V222.7a.81.81,0,0,0-.821-.8.788.788,0,0,0-.789.8v1.885a.155.155,0,0,1-.016.079.432.432,0,0,1-.418.339.417.417,0,0,1-.418-.418V221.48a.417.417,0,0,1,.418-.418.429.429,0,0,1,.387.245,1.586,1.586,0,0,1,.837-.245A1.652,1.652,0,0,1,141.5,222.7",
    transform: "translate(-115.539 -219.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M141.675,223.042a2.007,2.007,0,0,1,2-1.979,2.081,2.081,0,0,1,1.255.434.434.434,0,0,1,.087.584.42.42,0,0,1-.592.078,1.259,1.259,0,0,0-.75-.252,1.132,1.132,0,1,0,0,2.263,1.277,1.277,0,0,0,.75-.251.43.43,0,0,1,.592.085.436.436,0,0,1-.087.584,2.175,2.175,0,0,1-1.255.418,2,2,0,0,1-2-1.964",
    transform: "translate(-114.445 -219.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M145.626,224.43a1.963,1.963,0,0,1-.543-1.387,2.029,2.029,0,0,1,.543-1.38,1.844,1.844,0,0,1,1.358-.6,1.745,1.745,0,0,1,1.317.6,1.966,1.966,0,0,1,.553,1.38,1.9,1.9,0,0,1-.553,1.387,1.744,1.744,0,0,1-1.317.6,1.843,1.843,0,0,1-1.358-.6m.316-1.387a1.276,1.276,0,0,0,.284.836,1.067,1.067,0,0,0,.758.291,1.029,1.029,0,0,0,.725-.291,1.212,1.212,0,0,0,.308-.836,1.186,1.186,0,0,0-.308-.821,1.119,1.119,0,0,0-.725-.3,1.154,1.154,0,0,0-.758.3,1.248,1.248,0,0,0-.284.821",
    transform: "translate(-113.37 -219.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M149.376,224.43a1.962,1.962,0,0,1-.543-1.387,2.028,2.028,0,0,1,.543-1.38,1.844,1.844,0,0,1,1.358-.6,1.745,1.745,0,0,1,1.317.6,1.966,1.966,0,0,1,.553,1.38,1.9,1.9,0,0,1-.553,1.387,1.745,1.745,0,0,1-1.317.6,1.843,1.843,0,0,1-1.358-.6m.316-1.387a1.276,1.276,0,0,0,.284.836,1.067,1.067,0,0,0,.758.291,1.029,1.029,0,0,0,.725-.291,1.212,1.212,0,0,0,.308-.836,1.186,1.186,0,0,0-.308-.821,1.118,1.118,0,0,0-.725-.3,1.154,1.154,0,0,0-.758.3,1.247,1.247,0,0,0-.284.821",
    transform: "translate(-112.187 -219.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M152.72,226.063v-4.582a.421.421,0,0,1,.418-.418.433.433,0,0,1,.434.323,2,2,0,0,1,1.073-.323,1.956,1.956,0,0,1,1.909,1.979A1.936,1.936,0,0,1,154.646,225a1.826,1.826,0,0,1-1.058-.324v1.389a.445.445,0,0,1-.45.426.433.433,0,0,1-.418-.426m.868-3.021a1.052,1.052,0,0,0,.308.789.977.977,0,0,0,.75.331,1.007,1.007,0,0,0,.741-.331,1.15,1.15,0,0,0,.308-.789,1.211,1.211,0,0,0-.308-.8,1.024,1.024,0,0,0-.741-.325.993.993,0,0,0-.75.325,1.1,1.1,0,0,0-.308.8",
    transform: "translate(-110.96 -219.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M156.41,223.035a1.955,1.955,0,0,1,1.926-1.973,1.887,1.887,0,0,1,1.9,1.831v.04a.218.218,0,0,1-.008.071.381.381,0,0,1-.41.316H157.31a1.03,1.03,0,0,0,.268.519,1.22,1.22,0,0,0,.758.355,1.288,1.288,0,0,0,.819-.2.449.449,0,0,1,.592-.024.36.36,0,0,1,0,.513,1.994,1.994,0,0,1-1.411.521,1.959,1.959,0,0,1-1.926-1.972m.86-.387H159.5a1.29,1.29,0,0,0-1.167-.836,1.1,1.1,0,0,0-1.066.836",
    transform: "translate(-109.796 -219.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M162.579,221.478a.421.421,0,0,1-.418.418.754.754,0,0,0-.474.15,1.192,1.192,0,0,0-.363.379,2.374,2.374,0,0,0-.322.663v1.5a.431.431,0,0,1-.434.418.421.421,0,0,1-.418-.418v-3.108a.414.414,0,0,1,.418-.41.424.424,0,0,1,.434.41v.055a.97.97,0,0,1,.165-.158,1.731,1.731,0,0,1,.994-.308.409.409,0,0,1,.418.41",
    transform: "translate(-108.617 -219.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M166.208,224.95a.428.428,0,0,1-.434.434h-2.807a.43.43,0,0,1-.324-.142.435.435,0,0,1,.024-.615L165,222.513a.988.988,0,0,0,.33-.757,1.021,1.021,0,0,0-.259-.687,1,1,0,0,0-.758-.332,1.032,1.032,0,0,0-.687.262l-.243.221a.431.431,0,0,1-.616-.033.435.435,0,0,1,.032-.615l.245-.22a1.859,1.859,0,0,1,1.269-.489,1.9,1.9,0,0,1,1.4.622,1.863,1.863,0,0,1,.489,1.271,1.9,1.9,0,0,1-.624,1.4l-1.49,1.348h1.68a.435.435,0,0,1,.434.442",
    transform: "translate(-107.867 -219.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M167.846,220.3v4.653a.439.439,0,0,1-.442.434.427.427,0,0,1-.433-.434v-3.881l-.317.183a.4.4,0,0,1-.221.062.441.441,0,0,1-.228-.811l.97-.576c.008-.008.024-.008.032-.016s.024-.016.04-.024.031-.008.047-.008a.048.048,0,0,1,.032-.008.133.133,0,0,1,.055-.008h.087a.047.047,0,0,0,.032.008.085.085,0,0,1,.047.016.048.048,0,0,1,.032.008c.024.016.032.024.047.024a.11.11,0,0,0,.032.024c.008.008.024.016.032.024s.024.024.032.032a.111.111,0,0,1,.024.032l.032.032.008.016c0,.008.008.016.008.024s.016.024.016.039.008.032.016.039a.339.339,0,0,0,.008.039.067.067,0,0,0,.016.055Z",
    transform: "translate(-106.773 -219.863)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    "data-name": "Path 3855",
    d: "M126.747,243.059a2.3,2.3,0,0,1-.637-1.621,2.375,2.375,0,0,1,.637-1.612,2.15,2.15,0,0,1,1.584-.7,2.036,2.036,0,0,1,1.539.7,2.3,2.3,0,0,1,.645,1.612,2.23,2.23,0,0,1-.645,1.621,2.037,2.037,0,0,1-1.539.7,2.151,2.151,0,0,1-1.584-.7m.368-1.621a1.494,1.494,0,0,0,.332.977,1.247,1.247,0,0,0,.884.341,1.212,1.212,0,0,0,.848-.341,1.42,1.42,0,0,0,.359-.977,1.384,1.384,0,0,0-.359-.957,1.307,1.307,0,0,0-.848-.35,1.338,1.338,0,0,0-.884.35,1.455,1.455,0,0,0-.332.957",
    transform: "translate(194.326 27.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    "data-name": "Path 3856",
    d: "M134.5,241.032v2.211a.492.492,0,0,1-.489.488.505.505,0,0,1-.5-.488v-2.211a.94.94,0,0,0-1.88.028v2.183c0,.019-.01.046-.01.064v.028a.122.122,0,0,1-.028.055v.046a.538.538,0,0,1-.46.295c-.037,0-.063-.009-.091-.009a.5.5,0,0,1-.4-.479v-3.619a.488.488,0,0,1,.488-.5.469.469,0,0,1,.443.276,1.937,1.937,0,0,1,.985-.276,1.907,1.907,0,0,1,1.446.637,1.9,1.9,0,0,1,1.447-.637,1.924,1.924,0,0,1,1.917,1.935v2.183a.491.491,0,0,1-.488.488.5.5,0,0,1-.5-.488V241.06a.944.944,0,0,0-.931-.948.956.956,0,0,0-.958.921",
    transform: "translate(195.629 27.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3857",
    "data-name": "Path 3857",
    d: "M137.059,241.428a2.279,2.279,0,0,1,2.248-2.3,2.2,2.2,0,0,1,2.219,2.137v.046a.224.224,0,0,1-.011.083.444.444,0,0,1-.479.368h-2.929a1.221,1.221,0,0,0,.313.609,1.432,1.432,0,0,0,.887.414,1.5,1.5,0,0,0,.956-.23.52.52,0,0,1,.691-.028.419.419,0,0,1,0,.6,2.326,2.326,0,0,1-1.647.608,2.284,2.284,0,0,1-2.248-2.3m1-.451h2.606a1.5,1.5,0,0,0-1.362-.976,1.288,1.288,0,0,0-1.244.976",
    transform: "translate(197.506 27.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M126.412,264.338a.507.507,0,0,1-.516.508.522.522,0,0,1-.488-.377.5.5,0,0,1-.018-.13V258.9a.511.511,0,0,1,1.022,0v1.6a2.1,2.1,0,0,1,.985-.267,2.014,2.014,0,0,1,2.009,2.018v2.081a.506.506,0,1,1-1.013,0v-2.081a.991.991,0,1,0-1.981,0Z",
    transform: "translate(194.119 33.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M130.156,263.732a2.3,2.3,0,0,1-.637-1.622,2.374,2.374,0,0,1,.637-1.612,2.151,2.151,0,0,1,1.584-.7,2.038,2.038,0,0,1,1.539.7,2.3,2.3,0,0,1,.645,1.612,2.231,2.231,0,0,1-.645,1.622,2.042,2.042,0,0,1-1.539.7,2.156,2.156,0,0,1-1.584-.7m.368-1.622a1.492,1.492,0,0,0,.331.977,1.246,1.246,0,0,0,.884.341,1.211,1.211,0,0,0,.848-.341,1.417,1.417,0,0,0,.359-.977,1.384,1.384,0,0,0-.359-.957,1.307,1.307,0,0,0-.848-.35,1.338,1.338,0,0,0-.884.35,1.456,1.456,0,0,0-.331.957",
    transform: "translate(195.315 33.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M136.108,260.747a.52.52,0,0,1-.516.506h-.23v2.57a.507.507,0,0,1,.506.514.5.5,0,0,1-.506.508,1.027,1.027,0,0,1-1.023-1.022v-2.57h-.267a.506.506,0,0,1-.506-.506.5.5,0,0,1,.506-.508h.267V258.9a.509.509,0,0,1,.517-.508.5.5,0,0,1,.506.508v1.335h.23a.513.513,0,0,1,.516.508",
    transform: "translate(196.504 33.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M137.093,263.732a2.3,2.3,0,0,1-.637-1.622,2.374,2.374,0,0,1,.637-1.612,2.151,2.151,0,0,1,1.584-.7,2.037,2.037,0,0,1,1.539.7,2.3,2.3,0,0,1,.645,1.612,2.231,2.231,0,0,1-.645,1.622,2.042,2.042,0,0,1-1.539.7,2.156,2.156,0,0,1-1.584-.7m.368-1.622a1.492,1.492,0,0,0,.332.977,1.246,1.246,0,0,0,.884.341,1.209,1.209,0,0,0,.848-.341,1.417,1.417,0,0,0,.359-.977,1.384,1.384,0,0,0-.359-.957,1.3,1.3,0,0,0-.848-.35,1.338,1.338,0,0,0-.884.35,1.456,1.456,0,0,0-.332.957",
    transform: "translate(197.332 33.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M140.85,263.087a.48.48,0,0,1,.691-.075,1.684,1.684,0,0,0,1.013.406,1.241,1.241,0,0,0,.628-.175.377.377,0,0,0,.166-.277.138.138,0,0,0-.028-.092c-.009-.027-.046-.064-.12-.11a2.12,2.12,0,0,0-.737-.256h-.009a3.6,3.6,0,0,1-.8-.241,1.536,1.536,0,0,1-.635-.534,1.12,1.12,0,0,1-.157-.58,1.3,1.3,0,0,1,.543-1.014,1.982,1.982,0,0,1,1.134-.341,2.359,2.359,0,0,1,1.381.508.507.507,0,0,1,.147.68.488.488,0,0,1-.681.129,1.585,1.585,0,0,0-.847-.339.94.94,0,0,0-.554.164.284.284,0,0,0-.147.213.1.1,0,0,0,.018.072.232.232,0,0,0,.1.092,1.827,1.827,0,0,0,.672.221l.009.011h.011a3.366,3.366,0,0,1,.856.267,1.431,1.431,0,0,1,.654.543,1.193,1.193,0,0,1,.175.608,1.328,1.328,0,0,1-.58,1.069,2.1,2.1,0,0,1-1.2.368,2.676,2.676,0,0,1-1.639-.635.491.491,0,0,1-.064-.681",
    transform: "translate(198.583 33.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M126.251,279.759a.5.5,0,0,1-.5.508.5.5,0,0,1-.5-.508v-.192a.5.5,0,0,1,.5-.5.491.491,0,0,1,.5.5Zm0,1.668v3.593a.489.489,0,0,1-.5.5.5.5,0,0,1-.5-.5v-3.593a.492.492,0,0,1,.5-.506.486.486,0,0,1,.5.506",
    transform: "translate(194.098 39.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M127.216,285.011v-5.434a.506.506,0,0,1,.506-.508.514.514,0,0,1,.516.508v3.187l1.889-1.889a.52.52,0,0,1,.718,0,.5.5,0,0,1,0,.719l-1.381,1.381,1.419,1.7a.513.513,0,0,1-.075.719.495.495,0,0,1-.709-.066l-1.354-1.639-.508.506v.81a.514.514,0,0,1-.516.508.506.506,0,0,1-.506-.508",
    transform: "translate(194.652 39.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M130.716,282.774a2.28,2.28,0,0,1,2.248-2.3,2.2,2.2,0,0,1,2.221,2.137v.046a.215.215,0,0,1-.01.081.445.445,0,0,1-.479.37h-2.93a1.213,1.213,0,0,0,.313.608,1.422,1.422,0,0,0,.885.414,1.5,1.5,0,0,0,.958-.23.52.52,0,0,1,.691-.028.421.421,0,0,1,0,.6,2.329,2.329,0,0,1-1.648.609,2.287,2.287,0,0,1-2.248-2.3m1-.452h2.607a1.505,1.505,0,0,0-1.363-.976,1.287,1.287,0,0,0-1.244.976",
    transform: "translate(195.663 40.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M135.082,283.759a.48.48,0,0,1,.691-.074,1.676,1.676,0,0,0,1.013.4,1.229,1.229,0,0,0,.627-.175.376.376,0,0,0,.166-.276.137.137,0,0,0-.028-.092c-.009-.028-.046-.064-.12-.11a2.131,2.131,0,0,0-.737-.258h-.009a3.57,3.57,0,0,1-.8-.24,1.538,1.538,0,0,1-.635-.534,1.12,1.12,0,0,1-.157-.581,1.293,1.293,0,0,1,.543-1.013,1.986,1.986,0,0,1,1.134-.341,2.359,2.359,0,0,1,1.381.506.509.509,0,0,1,.147.681.487.487,0,0,1-.681.129,1.588,1.588,0,0,0-.847-.34.942.942,0,0,0-.554.166c-.118.084-.147.166-.147.212a.1.1,0,0,0,.018.074.259.259,0,0,0,.1.092,1.855,1.855,0,0,0,.674.221l.008.009h.011a3.422,3.422,0,0,1,.856.267,1.441,1.441,0,0,1,.654.544,1.194,1.194,0,0,1,.176.608,1.333,1.333,0,0,1-.581,1.069,2.107,2.107,0,0,1-1.2.368,2.683,2.683,0,0,1-1.639-.635.492.492,0,0,1-.064-.682",
    transform: "translate(196.906 40.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M125.83,303.9v-3.656a.5.5,0,0,1,1,0v1.732a2.186,2.186,0,0,1,1.235-.388,2.3,2.3,0,0,1,0,4.606,2.251,2.251,0,0,1-1.254-.4.5.5,0,0,1-.488.4.5.5,0,0,1-.5-.5Zm1,0a1.29,1.29,0,0,0,.368.911,1.179,1.179,0,0,0,1.732,0,1.291,1.291,0,0,0,.37-.911,1.311,1.311,0,0,0-.37-.93,1.183,1.183,0,0,0-1.732,0,1.31,1.31,0,0,0-.368.93",
    transform: "translate(194.245 46.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M130.926,305.076a2.3,2.3,0,0,1-.637-1.622,2.375,2.375,0,0,1,.637-1.612,2.151,2.151,0,0,1,1.584-.7,2.037,2.037,0,0,1,1.539.7,2.3,2.3,0,0,1,.645,1.612,2.231,2.231,0,0,1-.645,1.622,2.038,2.038,0,0,1-1.539.7,2.152,2.152,0,0,1-1.584-.7m.368-1.622a1.49,1.49,0,0,0,.331.977,1.246,1.246,0,0,0,.884.341,1.211,1.211,0,0,0,.848-.341,1.415,1.415,0,0,0,.359-.977,1.378,1.378,0,0,0-.359-.956,1.3,1.3,0,0,0-.848-.351,1.334,1.334,0,0,0-.884.351,1.449,1.449,0,0,0-.331.956",
    transform: "translate(195.541 46.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M136.56,305.748a1.927,1.927,0,0,1-1.917-1.916v-2.2a.5.5,0,0,1,.488-.488.493.493,0,0,1,.489.488v2.2a.932.932,0,0,0,.939.94.956.956,0,0,0,.967-.94v-2.2a.485.485,0,0,1,.48-.488.513.513,0,0,1,.5.488v2.2a1.944,1.944,0,0,1-1.944,1.916",
    transform: "translate(196.808 46.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M141.19,302.091a.519.519,0,0,1-.516.506h-.23v2.57a.507.507,0,0,1,.506.517.5.5,0,0,1-.506.5,1.026,1.026,0,0,1-1.023-1.022V302.6h-.267a.5.5,0,0,1-.506-.506.5.5,0,0,1,.506-.508h.267v-1.335a.508.508,0,0,1,.517-.506.5.5,0,0,1,.507.506v1.335h.23a.513.513,0,0,1,.516.508",
    transform: "translate(197.983 46.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M121.168,323.6a3.358,3.358,0,0,1,3.4-3.325,3.406,3.406,0,0,1,2.1.718.529.529,0,0,1,.1.746.536.536,0,0,1-.746.083,2.393,2.393,0,0,0-1.456-.5,2.283,2.283,0,0,0-1.657.671,2.182,2.182,0,0,0,0,3.188,2.284,2.284,0,0,0,1.657.672,2.541,2.541,0,0,0,1.263-.35v-1.262h-1.318a.53.53,0,0,1-.525-.525.517.517,0,0,1,.525-.516h1.834a.519.519,0,0,1,.534.516v2.036a.72.72,0,0,1-.028.156c-.009.02-.009.028-.018.046v.009a.437.437,0,0,1-.175.221,3.392,3.392,0,0,1-2.092.719,3.35,3.35,0,0,1-3.4-3.308",
    transform: "translate(192.882 52.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M129.843,322.3a.491.491,0,0,1-.488.488.886.886,0,0,0-.554.175,1.377,1.377,0,0,0-.424.443,2.806,2.806,0,0,0-.378.773v1.75a.5.5,0,0,1-.506.488.491.491,0,0,1-.488-.488V322.3a.483.483,0,0,1,.488-.479.494.494,0,0,1,.506.479v.064a1.212,1.212,0,0,1,.193-.184,2.023,2.023,0,0,1,1.162-.359.478.478,0,0,1,.488.479",
    transform: "translate(194.595 53.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M130.38,325.747a2.29,2.29,0,0,1-.637-1.62,2.371,2.371,0,0,1,.637-1.612,2.151,2.151,0,0,1,1.584-.7,2.037,2.037,0,0,1,1.539.7,2.3,2.3,0,0,1,.645,1.612,2.225,2.225,0,0,1-.645,1.62,2.034,2.034,0,0,1-1.539.7,2.147,2.147,0,0,1-1.584-.7m.368-1.62a1.489,1.489,0,0,0,.332.976,1.248,1.248,0,0,0,.884.342,1.21,1.21,0,0,0,.848-.342,1.414,1.414,0,0,0,.359-.976,1.39,1.39,0,0,0-.359-.959,1.3,1.3,0,0,0-.848-.348,1.338,1.338,0,0,0-.884.348,1.463,1.463,0,0,0-.332.959",
    transform: "translate(195.381 53.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M136.014,326.421A1.927,1.927,0,0,1,134.1,324.5v-2.2a.5.5,0,0,1,.489-.488.492.492,0,0,1,.488.488v2.2a.932.932,0,0,0,.939.94.955.955,0,0,0,.967-.94v-2.2a.484.484,0,0,1,.48-.488.512.512,0,0,1,.5.488v2.2a1.944,1.944,0,0,1-1.944,1.916",
    transform: "translate(196.651 53.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M138.458,327.656V322.3a.491.491,0,0,1,.489-.488.505.505,0,0,1,.506.377,2.337,2.337,0,0,1,1.252-.377,2.285,2.285,0,0,1,2.23,2.312,2.26,2.26,0,0,1-2.23,2.284,2.13,2.13,0,0,1-1.234-.377v1.622a.52.52,0,0,1-.525.5.506.506,0,0,1-.489-.5m1.014-3.529a1.227,1.227,0,0,0,.359.921,1.14,1.14,0,0,0,.875.387,1.181,1.181,0,0,0,.867-.387,1.342,1.342,0,0,0,.359-.921,1.42,1.42,0,0,0-.359-.93,1.205,1.205,0,0,0-.867-.377,1.163,1.163,0,0,0-.875.377,1.292,1.292,0,0,0-.359.93",
    transform: "translate(197.915 53.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M142.936,325.1a.48.48,0,0,1,.691-.074,1.678,1.678,0,0,0,1.013.405,1.23,1.23,0,0,0,.627-.175.377.377,0,0,0,.166-.276.138.138,0,0,0-.028-.092c-.009-.028-.046-.064-.12-.11a2.13,2.13,0,0,0-.737-.258h-.009a3.57,3.57,0,0,1-.8-.239,1.537,1.537,0,0,1-.635-.534,1.121,1.121,0,0,1-.157-.581,1.293,1.293,0,0,1,.543-1.013,1.986,1.986,0,0,1,1.134-.34,2.36,2.36,0,0,1,1.381.506.509.509,0,0,1,.147.681.488.488,0,0,1-.681.129,1.578,1.578,0,0,0-.847-.341.943.943,0,0,0-.554.166.283.283,0,0,0-.146.212.1.1,0,0,0,.017.074.259.259,0,0,0,.1.092,1.851,1.851,0,0,0,.673.221l.008.009h.011a3.43,3.43,0,0,1,.856.267,1.442,1.442,0,0,1,.654.544,1.194,1.194,0,0,1,.176.608,1.334,1.334,0,0,1-.581,1.069,2.107,2.107,0,0,1-1.2.368,2.687,2.687,0,0,1-1.639-.635.493.493,0,0,1-.064-.682",
    transform: "translate(199.191 53.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3394",
    "data-name": "Rectangle 3394",
    width: 52.147,
    height: 19.075,
    transform: "translate(670.024 191.391)",
    fill: "#7d93b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3395",
    "data-name": "Rectangle 3395",
    width: 52.147,
    height: 19.075,
    transform: "translate(733.246 191.391)",
    fill: "#7d93b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3396",
    "data-name": "Rectangle 3396",
    width: 52.147,
    height: 19.075,
    transform: "translate(795.787 191.391)",
    fill: "#7d93b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    "data-name": "Path 3756",
    d: "M254.168,192.342h-1.133v2a.511.511,0,0,1-1.022,0v-5.434a.5.5,0,0,1,.506-.506h1.648a1.971,1.971,0,1,1,0,3.942m-1.133-1.022h1.133a.948.948,0,1,0,0-1.9h-1.133Z",
    transform: "translate(230.924 11.691)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    d: "M255.7,192.1a2.281,2.281,0,0,1,2.248-2.3,2.2,2.2,0,0,1,2.221,2.137v.046a.254.254,0,0,1-.009.083.444.444,0,0,1-.48.368h-2.93a1.221,1.221,0,0,0,.313.609,1.428,1.428,0,0,0,.885.414,1.5,1.5,0,0,0,.958-.23.52.52,0,0,1,.691-.027.419.419,0,0,1,0,.6,2.328,2.328,0,0,1-1.648.607,2.286,2.286,0,0,1-2.248-2.3m1-.451h2.607a1.505,1.505,0,0,0-1.363-.976,1.288,1.288,0,0,0-1.244.976",
    transform: "translate(231.994 12.124)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    d: "M262.9,190.287a.492.492,0,0,1-.488.489.888.888,0,0,0-.553.173,1.372,1.372,0,0,0-.425.443,2.829,2.829,0,0,0-.378.773v1.75a.5.5,0,0,1-.507.488.491.491,0,0,1-.488-.488v-3.63a.483.483,0,0,1,.488-.479.494.494,0,0,1,.507.479v.064a1.209,1.209,0,0,1,.193-.184,2.023,2.023,0,0,1,1.162-.359.478.478,0,0,1,.488.479",
    transform: "translate(233.276 12.128)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    d: "M262.993,193.089a.479.479,0,0,1,.691-.074,1.691,1.691,0,0,0,1.013.405,1.23,1.23,0,0,0,.627-.175.377.377,0,0,0,.166-.276.138.138,0,0,0-.028-.092c-.009-.028-.046-.064-.12-.111a2.136,2.136,0,0,0-.737-.258H264.6a3.522,3.522,0,0,1-.8-.241,1.518,1.518,0,0,1-.635-.534,1.115,1.115,0,0,1-.157-.58,1.292,1.292,0,0,1,.543-1.013,1.981,1.981,0,0,1,1.134-.341,2.36,2.36,0,0,1,1.381.506.509.509,0,0,1,.147.681.487.487,0,0,1-.681.129,1.578,1.578,0,0,0-.847-.341.939.939,0,0,0-.554.166.277.277,0,0,0-.146.212.106.106,0,0,0,.017.074.248.248,0,0,0,.1.092,1.88,1.88,0,0,0,.673.221l.008.009h.01a3.363,3.363,0,0,1,.856.267,1.441,1.441,0,0,1,.654.544,1.188,1.188,0,0,1,.175.608,1.328,1.328,0,0,1-.58,1.068,2.087,2.087,0,0,1-1.2.368,2.672,2.672,0,0,1-1.639-.635.491.491,0,0,1-.064-.681",
    transform: "translate(234.088 12.125)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    d: "M267.054,193.734a2.3,2.3,0,0,1-.637-1.622,2.377,2.377,0,0,1,.637-1.612,2.151,2.151,0,0,1,1.584-.7,2.036,2.036,0,0,1,1.539.7,2.306,2.306,0,0,1,.645,1.612,2.23,2.23,0,0,1-.645,1.622,2.036,2.036,0,0,1-1.539.7,2.151,2.151,0,0,1-1.584-.7m.368-1.622a1.494,1.494,0,0,0,.332.977,1.246,1.246,0,0,0,.884.341,1.21,1.21,0,0,0,.849-.341,1.42,1.42,0,0,0,.359-.977,1.384,1.384,0,0,0-.359-.958,1.306,1.306,0,0,0-.849-.35,1.339,1.339,0,0,0-.884.35,1.456,1.456,0,0,0-.332.958",
    transform: "translate(235.107 12.125)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    d: "M274.8,191.717v2.2a.483.483,0,0,1-.479.488.5.5,0,0,1-.488-.488v-2.2a.945.945,0,0,0-.959-.93.919.919,0,0,0-.921.93v2.2a.181.181,0,0,1-.019.092.5.5,0,0,1-.488.4.486.486,0,0,1-.489-.488v-3.63a.486.486,0,0,1,.489-.488.5.5,0,0,1,.451.285,1.837,1.837,0,0,1,.976-.285,1.928,1.928,0,0,1,1.926,1.916",
    transform: "translate(236.43 12.125)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    "data-name": "Path 3762",
    d: "M279.259,192.113v1.806a.491.491,0,0,1-.488.488.5.5,0,0,1-.479-.4,2.092,2.092,0,0,1-1.225.4,2.139,2.139,0,0,1-1.567-.672,2.35,2.35,0,0,1-.626-1.622,2.316,2.316,0,0,1,.626-1.62,2.092,2.092,0,0,1,2.791-.287.5.5,0,0,1,.479-.405.493.493,0,0,1,.488.5Zm-.976,0a1.354,1.354,0,0,0-.359-.948,1.139,1.139,0,0,0-.856-.377,1.111,1.111,0,0,0-.858.377,1.348,1.348,0,0,0-.35.948,1.384,1.384,0,0,0,.35.95,1.16,1.16,0,0,0,.858.359,1.191,1.191,0,0,0,.856-.359,1.39,1.39,0,0,0,.359-.95",
    transform: "translate(237.566 12.125)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    d: "M280.232,188.4a.514.514,0,0,1,.517.506v5.436a.512.512,0,0,1-1.024,0v-5.436a.511.511,0,0,1,.506-.506",
    transform: "translate(239.01 11.691)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    d: "M283.645,188.906a.5.5,0,0,1,.506-.506.513.513,0,0,1,.516.506v5.434a.512.512,0,0,1-.516.506.5.5,0,0,1-.506-.506Z",
    transform: "translate(240.149 11.691)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    d: "M289.5,191.717v2.2a.483.483,0,0,1-.479.488.5.5,0,0,1-.488-.488v-2.2a.945.945,0,0,0-.959-.93.919.919,0,0,0-.921.93v2.2a.18.18,0,0,1-.019.092.5.5,0,0,1-.488.4.485.485,0,0,1-.488-.488v-3.63a.485.485,0,0,1,.488-.488.5.5,0,0,1,.451.285,1.837,1.837,0,0,1,.976-.285,1.928,1.928,0,0,1,1.926,1.916",
    transform: "translate(240.703 12.125)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    d: "M292.131,190.749a.519.519,0,0,1-.516.506h-.23v2.57a.507.507,0,0,1,.506.517.5.5,0,0,1-.506.506,1.027,1.027,0,0,1-1.024-1.023v-2.57h-.267a.5.5,0,0,1-.506-.506.5.5,0,0,1,.506-.506h.267v-1.336a.508.508,0,0,1,.517-.506.5.5,0,0,1,.507.506v1.336h.23a.513.513,0,0,1,.516.506",
    transform: "translate(241.861 11.691)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    "data-name": "Path 3767",
    d: "M292.22,192.1a2.281,2.281,0,0,1,2.248-2.3,2.2,2.2,0,0,1,2.221,2.137v.046a.22.22,0,0,1-.011.083.444.444,0,0,1-.479.368h-2.93a1.21,1.21,0,0,0,.313.609,1.428,1.428,0,0,0,.885.414,1.505,1.505,0,0,0,.958-.23.52.52,0,0,1,.691-.027.42.42,0,0,1,0,.6,2.327,2.327,0,0,1-1.648.607,2.286,2.286,0,0,1-2.248-2.3m1-.451h2.607a1.505,1.505,0,0,0-1.363-.976,1.289,1.289,0,0,0-1.244.976",
    transform: "translate(242.608 12.124)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768",
    "data-name": "Path 3768",
    d: "M299.418,190.287a.492.492,0,0,1-.488.489.894.894,0,0,0-.554.173,1.38,1.38,0,0,0-.424.443,2.826,2.826,0,0,0-.378.773v1.75a.5.5,0,0,1-.507.488.491.491,0,0,1-.488-.488v-3.63a.483.483,0,0,1,.488-.479.494.494,0,0,1,.507.479v.064a1.205,1.205,0,0,1,.194-.184,2.022,2.022,0,0,1,1.161-.359.478.478,0,0,1,.488.479",
    transform: "translate(243.891 12.128)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769",
    "data-name": "Path 3769",
    d: "M299.06,192.1a2.28,2.28,0,0,1,2.247-2.3,2.2,2.2,0,0,1,2.22,2.137v.046a.222.222,0,0,1-.011.083.443.443,0,0,1-.477.368h-2.931a1.211,1.211,0,0,0,.313.609,1.428,1.428,0,0,0,.885.414,1.5,1.5,0,0,0,.958-.23.52.52,0,0,1,.691-.027.421.421,0,0,1,0,.6,2.322,2.322,0,0,1-1.648.607,2.285,2.285,0,0,1-2.247-2.3m1-.451h2.607a1.507,1.507,0,0,0-1.364-.976,1.286,1.286,0,0,0-1.243.976",
    transform: "translate(244.596 12.124)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770",
    "data-name": "Path 3770",
    d: "M303.425,193.089a.479.479,0,0,1,.691-.074,1.691,1.691,0,0,0,1.013.405,1.231,1.231,0,0,0,.628-.175.377.377,0,0,0,.166-.276.137.137,0,0,0-.028-.092c-.009-.028-.046-.064-.12-.111a2.134,2.134,0,0,0-.737-.258h-.009a3.541,3.541,0,0,1-.8-.241,1.518,1.518,0,0,1-.635-.534,1.115,1.115,0,0,1-.157-.58,1.293,1.293,0,0,1,.544-1.013,1.985,1.985,0,0,1,1.134-.341,2.358,2.358,0,0,1,1.381.506.508.508,0,0,1,.147.681.487.487,0,0,1-.681.129,1.578,1.578,0,0,0-.847-.341.939.939,0,0,0-.554.166.282.282,0,0,0-.146.212.1.1,0,0,0,.017.074.268.268,0,0,0,.1.092,1.879,1.879,0,0,0,.674.221l.008.009h.01a3.367,3.367,0,0,1,.856.267,1.443,1.443,0,0,1,.654.544,1.187,1.187,0,0,1,.175.608,1.328,1.328,0,0,1-.58,1.068,2.087,2.087,0,0,1-1.2.368,2.671,2.671,0,0,1-1.639-.635.491.491,0,0,1-.065-.681",
    transform: "translate(245.842 12.125)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771",
    "data-name": "Path 3771",
    d: "M309.3,190.749a.519.519,0,0,1-.516.506h-.23v2.57a.507.507,0,0,1,.507.517.5.5,0,0,1-.507.506,1.027,1.027,0,0,1-1.023-1.023v-2.57h-.267a.5.5,0,0,1-.507-.506.5.5,0,0,1,.507-.506h.267v-1.336a.508.508,0,0,1,.517-.506.5.5,0,0,1,.507.506v1.336h.23a.513.513,0,0,1,.516.506",
    transform: "translate(246.852 11.691)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772",
    "data-name": "Path 3772",
    d: "M309.774,193.089a.479.479,0,0,1,.691-.074,1.69,1.69,0,0,0,1.013.405,1.229,1.229,0,0,0,.628-.175.377.377,0,0,0,.166-.276.136.136,0,0,0-.028-.092c-.009-.028-.046-.064-.12-.111a2.147,2.147,0,0,0-.737-.258h-.009a3.544,3.544,0,0,1-.8-.241,1.518,1.518,0,0,1-.635-.534,1.116,1.116,0,0,1-.156-.58,1.292,1.292,0,0,1,.543-1.013,1.984,1.984,0,0,1,1.134-.341,2.359,2.359,0,0,1,1.381.506.508.508,0,0,1,.147.681.487.487,0,0,1-.681.129,1.578,1.578,0,0,0-.847-.341.939.939,0,0,0-.554.166.28.28,0,0,0-.147.212.1.1,0,0,0,.018.074.256.256,0,0,0,.1.092,1.878,1.878,0,0,0,.674.221l.008.009h.01a3.366,3.366,0,0,1,.856.267,1.443,1.443,0,0,1,.654.544,1.19,1.19,0,0,1,.175.608,1.328,1.328,0,0,1-.58,1.068,2.086,2.086,0,0,1-1.2.368,2.668,2.668,0,0,1-1.639-.635.491.491,0,0,1-.064-.681",
    transform: "translate(247.688 12.125)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3829",
    "data-name": "Path 3829",
    d: "M251.8,232.656a3.381,3.381,0,0,1,3.381-3.315,3.447,3.447,0,0,1,2.129.718.529.529,0,0,1-.645.839,2.29,2.29,0,0,0-1.484-.508,2.444,2.444,0,0,0-1.659.663,2.283,2.283,0,0,0-.672,1.6,2.245,2.245,0,0,0,.672,1.6,2.444,2.444,0,0,0,1.659.663,2.314,2.314,0,0,0,1.484-.506.559.559,0,0,1,.737.1.543.543,0,0,1-.092.736,3.447,3.447,0,0,1-2.129.718,3.369,3.369,0,0,1-3.381-3.316",
    transform: "translate(230.846 24.422)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    "data-name": "Path 3830",
    d: "M262.424,230.326a3.384,3.384,0,0,1,0,4.661,3.014,3.014,0,0,1-2.2.985,3.106,3.106,0,0,1-2.257-.985,3.434,3.434,0,0,1,0-4.661,3.077,3.077,0,0,1,2.257-.985,2.986,2.986,0,0,1,2.2.985m-.12,2.331a2.39,2.39,0,0,0-.626-1.612,1.988,1.988,0,0,0-2.948,0,2.342,2.342,0,0,0-.628,1.612,2.3,2.3,0,0,0,.628,1.6,1.97,1.97,0,0,0,2.948,0,2.344,2.344,0,0,0,.626-1.6",
    transform: "translate(232.368 24.422)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    "data-name": "Path 3831",
    d: "M264.049,235.406a.5.5,0,1,1-1,0v-5.36a.5.5,0,0,1,.9-.313l2.976,4.116v-3.794a.5.5,0,0,1,.5-.5.509.509,0,0,1,.506.5v5.351a.511.511,0,0,1-.506.506.5.5,0,0,1-.377-.184.235.235,0,0,1-.046-.055l-2.948-4.09Z",
    transform: "translate(234.121 24.481)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    "data-name": "Path 3832",
    d: "M272.428,230.5h-1.465v4.919a.5.5,0,0,1-.506.506.505.505,0,0,1-.507-.506V230.5h-1.456a.513.513,0,0,1-.507-.517.5.5,0,0,1,.507-.506h3.934a.506.506,0,0,1,.507.506.519.519,0,0,1-.507.517",
    transform: "translate(235.56 24.466)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    "data-name": "Path 3833",
    d: "M275.618,234.407h-2.239l-.451,1.2a.515.515,0,0,1-.479.322.5.5,0,0,1-.175-.028.522.522,0,0,1-.3-.663l2.036-5.425a.513.513,0,0,1,.488-.322.5.5,0,0,1,.488.322l2.036,5.425a.522.522,0,0,1-.3.663.47.47,0,0,1-.175.028.5.5,0,0,1-.471-.322Zm-.378-1.014-.746-1.979-.746,1.979Z",
    transform: "translate(236.706 24.466)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3834",
    "data-name": "Path 3834",
    d: "M276.261,232.656a3.382,3.382,0,0,1,3.381-3.315,3.457,3.457,0,0,1,2.13.718.547.547,0,0,1,.091.738.541.541,0,0,1-.737.1,2.291,2.291,0,0,0-1.484-.508,2.438,2.438,0,0,0-1.658.663,2.278,2.278,0,0,0-.673,1.6,2.24,2.24,0,0,0,.673,1.6,2.438,2.438,0,0,0,1.658.663,2.315,2.315,0,0,0,1.484-.506.559.559,0,0,1,.737.1.545.545,0,0,1-.091.736,3.456,3.456,0,0,1-2.13.718,3.37,3.37,0,0,1-3.381-3.316",
    transform: "translate(237.955 24.422)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    d: "M285.938,230.5h-1.465v4.919a.5.5,0,0,1-.507.506.5.5,0,0,1-.506-.506V230.5H282a.513.513,0,0,1-.507-.517.5.5,0,0,1,.507-.506h3.935a.506.506,0,0,1,.506.506.519.519,0,0,1-.506.517",
    transform: "translate(239.486 24.466)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    "data-name": "Path 3836",
    d: "M288.56,229.987a.5.5,0,0,1,.507-.506.513.513,0,0,1,.516.506v5.434a.513.513,0,0,1-.516.508.5.5,0,0,1-.507-.508Z",
    transform: "translate(241.577 24.466)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3837",
    "data-name": "Path 3837",
    d: "M291.657,235.406a.5.5,0,1,1-1,0v-5.36a.5.5,0,0,1,.2-.423.506.506,0,0,1,.7.111l2.976,4.116v-3.794a.5.5,0,0,1,.5-.5.509.509,0,0,1,.507.5v5.351a.511.511,0,0,1-.507.506.5.5,0,0,1-.378-.184.244.244,0,0,1-.046-.055l-2.948-4.09Z",
    transform: "translate(242.148 24.481)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    "data-name": "Path 3838",
    d: "M296.043,235.422v-5.434a.506.506,0,0,1,.506-.508h3.012a.512.512,0,0,1,0,1.023h-2.5v1.686h2.147a.511.511,0,0,1,0,1.022h-2.147v2.211a.513.513,0,0,1-.516.506.5.5,0,0,1-.506-.506",
    transform: "translate(243.722 24.466)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3839",
    "data-name": "Path 3839",
    d: "M305.292,230.326a3.385,3.385,0,0,1,0,4.661,3.014,3.014,0,0,1-2.2.985,3.105,3.105,0,0,1-2.257-.985,3.434,3.434,0,0,1,0-4.661,3.076,3.076,0,0,1,2.257-.985,2.986,2.986,0,0,1,2.2.985m-.12,2.331a2.39,2.39,0,0,0-.626-1.612,1.989,1.989,0,0,0-2.948,0,2.342,2.342,0,0,0-.628,1.612,2.3,2.3,0,0,0,.628,1.6,1.97,1.97,0,0,0,2.948,0,2.344,2.344,0,0,0,.626-1.6",
    transform: "translate(244.826 24.422)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M251.795,241.719l46.6-.32,46.6-.116,93.192-.221,93.191.22,46.6.114,46.6.322-46.6.322-46.6.116-93.191.218-93.192-.221-46.6-.116Z",
    transform: "translate(224.549 28.07)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4471",
    "data-name": "Group 4471",
    transform: "translate(485.214 287.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M258.727,255c-.046.045-.087.084-.129.124l-2.032,1.936a.306.306,0,0,1-.467,0l-2.086-1.971-.081-.079a.31.31,0,0,1,.181-.049l1.411-.007,2.947-.01a.41.41,0,0,1,.256.055",
    transform: "translate(-253.739 -254.945)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    d: "M258.723,258.111a1.036,1.036,0,0,1-.175.032q-.845.006-1.689.008-1.356.006-2.714.012a.405.405,0,0,1-.218-.055l1.685-1.606.325.306.138.13a.365.365,0,0,0,.518,0c.149-.141.3-.284.451-.433l1.679,1.586v.02",
    transform: "translate(-253.74 -254.454)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    d: "M255.45,256.728c-.546.531-1.1,1.048-1.642,1.581a.48.48,0,0,1-.012-.078q-.008-1.487-.012-2.975a.835.835,0,0,1,.011-.092l1.655,1.564",
    transform: "translate(-253.785 -254.874)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M258.105,258.3l-.616-.585-1-.942c-.012-.01-.025-.02-.039-.031.548-.534,1.1-1.052,1.642-1.582.022.057.036,3.062.012,3.14",
    transform: "translate(-252.944 -254.879)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4470",
    "data-name": "Group 4470",
    transform: "translate(484.954 295.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    d: "M258.118,264.478l-.008.014a2.829,2.829,0,0,1-.272.351,2.641,2.641,0,0,1-.4.367,2.867,2.867,0,0,1-.933.468,3.2,3.2,0,0,1-.4.084l-.04.007h-.024l-.022-.015.026-.017a3.073,3.073,0,0,0,.755-.733,3.562,3.562,0,0,0,.309-.513.022.022,0,0,1,.024-.014h.98Z",
    transform: "translate(-252.819 -260.004)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4469",
    "data-name": "Group 4469",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    d: "M257.2,263.38c0,.028,0,.055,0,.083-.007.066-.011.132-.02.2-.013.091-.026.18-.045.27a3.268,3.268,0,0,1-.174.575.023.023,0,0,1-.025.017h-1.079V263.38Z",
    transform: "translate(-252.872 -260.349)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M255.95,263.4v1.125H254.9a.021.021,0,0,1-.022-.016,3.124,3.124,0,0,1-.179-.593c-.02-.105-.034-.21-.049-.316-.008-.07-.011-.139-.013-.209v-.007h1.3c.013,0,.017,0,.017.017",
    transform: "translate(-253.257 -260.35)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    "data-name": "Path 3919",
    d: "M256.81,264.478a3.124,3.124,0,0,1-.445.6,2.847,2.847,0,0,1-.508.431v-1.032Z",
    transform: "translate(-252.872 -260.004)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3920",
    "data-name": "Path 3920",
    d: "M255.852,264.478v1.011a2.934,2.934,0,0,1-.914-1.011Z",
    transform: "translate(-253.162 -260.004)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4468",
    "data-name": "Group 4468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    d: "M254.889,262.247a3.781,3.781,0,0,0-.258,1.177h-1.043V263.4c0-.026.007-.053.009-.08a2.72,2.72,0,0,1,.068-.41,3.208,3.208,0,0,1,.232-.643.024.024,0,0,1,.025-.014h.967Z",
    transform: "translate(-253.588 -260.706)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    d: "M254.857,264.522H253.9a.022.022,0,0,1-.024-.014,2.943,2.943,0,0,1-.238-.725,2.884,2.884,0,0,1-.047-.367l0-.012v-.029h1.025c.018,0,.018,0,.02.018.006.084.012.168.02.251a3.35,3.35,0,0,0,.064.395,3.687,3.687,0,0,0,.135.47l.005.014",
    transform: "translate(-253.588 -260.352)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    d: "M257.209,263.424h-1.346v-1.176h1.051a.021.021,0,0,1,.021.014,3.438,3.438,0,0,1,.266,1.061l.008.1",
    transform: "translate(-252.87 -260.706)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    d: "M255.948,262.253v1.177h-1.314c0-.029,0-.058.005-.088.007-.066.012-.132.022-.2.017-.1.034-.2.055-.3a3.075,3.075,0,0,1,.189-.58.021.021,0,0,1,.022-.014h1.019Z",
    transform: "translate(-253.258 -260.705)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M258.3,263.432h-1.1a3.834,3.834,0,0,0-.257-1.185h1.029a.022.022,0,0,1,.024.014,2.871,2.871,0,0,1,.254.737,3.122,3.122,0,0,1,.054.414v.02",
    transform: "translate(-252.531 -260.706)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M258.292,263.374c0,.026,0,.052,0,.077a2.734,2.734,0,0,1-.035.3,2.851,2.851,0,0,1-.2.663c-.014.034-.03.068-.046.1a.015.015,0,0,1-.016.01h-1.025c.012-.036.025-.07.036-.1a3.477,3.477,0,0,0,.137-.538,3.427,3.427,0,0,0,.047-.4c0-.032,0-.063.005-.095,0-.008,0-.013.012-.012h1.093Z",
    transform: "translate(-252.523 -260.352)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M258.088,262.316v0h-.979a.023.023,0,0,1-.024-.015,3.32,3.32,0,0,0-.479-.709,2.783,2.783,0,0,0-.367-.339c-.066-.05-.134-.1-.2-.146l-.011-.009.013-.009-.006-.02a2.842,2.842,0,0,1,.976.292,2.8,2.8,0,0,1,1.08.949",
    transform: "translate(-252.819 -261.075)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M255.98,265.758a.082.082,0,0,1-.029,0,2.5,2.5,0,0,1-.314-.06,2.817,2.817,0,0,1-.561-.208,2.862,2.862,0,0,1-.571-.373,2.812,2.812,0,0,1-.343-.343,2.9,2.9,0,0,1-.213-.3l-.005-.01h.016c.3,0,.6,0,.9,0a.023.023,0,0,1,.022.014,3.619,3.619,0,0,0,.33.538,3.533,3.533,0,0,0,.387.429,3.134,3.134,0,0,0,.374.3l.009.007",
    transform: "translate(-253.476 -260.005)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M255.96,261.1c-.041.03-.089.065-.135.1a3.325,3.325,0,0,0-.435.405,3.052,3.052,0,0,0-.457.651.5.5,0,0,1-.024.045.022.022,0,0,1-.014.009c-.016,0-.033,0-.049,0h-.877a2.864,2.864,0,0,1,1.981-1.232l-.005.012.016.01",
    transform: "translate(-253.468 -261.075)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M256.778,262.247h-.914v-.964a2.825,2.825,0,0,1,.513.429,3.275,3.275,0,0,1,.4.535",
    transform: "translate(-252.87 -261.011)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M255.843,261.3v.942h-.877a2.785,2.785,0,0,1,.877-.942",
    transform: "translate(-253.153 -261.003)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3923",
    "data-name": "Path 3923",
    d: "M258.542,251.414l.434,1.026-1.184-.487a3.083,3.083,0,0,1-1.408.329,2.175,2.175,0,1,1,2.67-2.117,1.893,1.893,0,0,1-.513,1.249",
    transform: "translate(231.412 30.24)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3924",
    "data-name": "Path 3924",
    d: "M257.559,280.723v5.435a.519.519,0,0,1-.517.506.5.5,0,0,1-.505-.506V282.28l-1.327,1.842a.506.506,0,0,1-.414.212h-.018a.527.527,0,0,1-.425-.212l-1.317-1.842v3.878a.511.511,0,0,1-1.022,0v-5.435a.511.511,0,0,1,.506-.506h.028a.5.5,0,0,1,.405.212l1.834,2.542,1.834-2.542a.5.5,0,0,1,.414-.212h.008a.526.526,0,0,1,.517.506",
    transform: "translate(230.911 40.244)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3925",
    "data-name": "Path 3925",
    d: "M262.76,281.064a3.385,3.385,0,0,1,0,4.661,3.016,3.016,0,0,1-2.2.984,3.11,3.11,0,0,1-2.257-.984,3.434,3.434,0,0,1,0-4.661,3.078,3.078,0,0,1,2.257-.986,2.985,2.985,0,0,1,2.2.986m-.12,2.329a2.39,2.39,0,0,0-.626-1.612,1.989,1.989,0,0,0-2.948,0,2.342,2.342,0,0,0-.627,1.612,2.3,2.3,0,0,0,.627,1.6,1.968,1.968,0,0,0,2.948,0,2.344,2.344,0,0,0,.626-1.6",
    transform: "translate(232.466 40.202)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3926",
    "data-name": "Path 3926",
    d: "M267.851,285.9a.507.507,0,0,1-.322.645.812.812,0,0,1-.2.028h-.009a.67.67,0,0,1-.359-.1.918.918,0,0,1-.295-.322,2.481,2.481,0,0,1-.193-1.106.771.771,0,0,0-.111-.4.852.852,0,0,0-.276-.267,1.8,1.8,0,0,0-.516-.222H264.48v2a.512.512,0,0,1-.516.505.5.5,0,0,1-.506-.505v-5.436a.5.5,0,0,1,.506-.506h1.648a1.97,1.97,0,0,1,1.254,3.492,1.446,1.446,0,0,1,.322.339,1.749,1.749,0,0,1,.3,1,2.33,2.33,0,0,0,.037.543.492.492,0,0,1,.322.314m-1.289-3.7a.95.95,0,0,0-.95-.959H264.48v1.9h1.133a.945.945,0,0,0,.95-.939",
    transform: "translate(234.247 40.244)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    "data-name": "Path 3927",
    d: "M267.931,286.159v-5.435a.5.5,0,0,1,.507-.506h3.012a.512.512,0,0,1,.508.506.521.521,0,0,1-.508.517h-2.5v1.685H271.1a.512.512,0,0,1,0,1.023h-2.147v1.694h2.5a.512.512,0,0,1,0,1.023h-2.985c-.018,0-.018-.009-.018-.009l-.009.009a.505.505,0,0,1-.507-.506",
    transform: "translate(235.552 40.244)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3928",
    "data-name": "Path 3928",
    d: "M274.231,280.723a.5.5,0,0,1,.507-.506.513.513,0,0,1,.516.506v5.435a.513.513,0,0,1-.516.506.5.5,0,0,1-.507-.506Z",
    transform: "translate(237.411 40.244)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3929",
    "data-name": "Path 3929",
    d: "M277.328,286.143a.5.5,0,1,1-1.005,0v-5.361a.5.5,0,0,1,.2-.423.506.506,0,0,1,.7.11l2.976,4.116v-3.794a.5.5,0,0,1,.5-.5.508.508,0,0,1,.507.5v5.351a.511.511,0,0,1-.507.506.5.5,0,0,1-.378-.184.284.284,0,0,1-.046-.055l-2.948-4.09Z",
    transform: "translate(237.983 40.259)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3930",
    "data-name": "Path 3930",
    d: "M281.714,286.159v-5.435a.5.5,0,0,1,.507-.506h3.012a.512.512,0,0,1,0,1.023h-2.5v1.685h2.147a.512.512,0,0,1,0,1.023h-2.147v2.211a.513.513,0,0,1-.516.506.5.5,0,0,1-.507-.506",
    transform: "translate(239.557 40.244)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3931",
    "data-name": "Path 3931",
    d: "M290.963,281.064a3.385,3.385,0,0,1,0,4.661,3.016,3.016,0,0,1-2.2.984,3.11,3.11,0,0,1-2.257-.984,3.434,3.434,0,0,1,0-4.661,3.078,3.078,0,0,1,2.257-.986,2.985,2.985,0,0,1,2.2.986m-.12,2.329a2.39,2.39,0,0,0-.626-1.612,1.989,1.989,0,0,0-2.948,0,2.342,2.342,0,0,0-.628,1.612,2.3,2.3,0,0,0,.628,1.6,1.968,1.968,0,0,0,2.948,0,2.345,2.345,0,0,0,.626-1.6",
    transform: "translate(240.662 40.202)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3932",
    "data-name": "Path 3932",
    d: "M251.795,292.456l46.6-.319,46.6-.116,93.192-.221,93.191.22,46.6.115,46.6.322-46.6.322-46.6.114-93.191.22-93.192-.221-46.6-.116Z",
    transform: "translate(224.549 43.854)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3397",
    "data-name": "Rectangle 3397",
    width: 67.181,
    height: 16.535,
    transform: "translate(780.79 276.615)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3933",
    "data-name": "Path 3933",
    d: "M488.6,255.04a.412.412,0,0,1,.576-.055,2.571,2.571,0,0,0,1.506.608,1.691,1.691,0,0,0,.987-.293.707.707,0,0,0,.339-.567.451.451,0,0,0-.071-.253.73.73,0,0,0-.237-.235,3.148,3.148,0,0,0-1.081-.372h-.016a4.211,4.211,0,0,1-1.017-.308,1.7,1.7,0,0,1-.734-.614,1.221,1.221,0,0,1-.18-.647,1.459,1.459,0,0,1,.63-1.152,2.338,2.338,0,0,1,1.364-.417,3.1,3.1,0,0,1,1.721.63.406.406,0,0,1,.11.56.4.4,0,0,1-.56.118,2.3,2.3,0,0,0-1.271-.505,1.512,1.512,0,0,0-.884.268.63.63,0,0,0-.3.5.382.382,0,0,0,.055.221.775.775,0,0,0,.213.205,2.737,2.737,0,0,0,.985.347h.017a4.579,4.579,0,0,1,1.088.331,1.82,1.82,0,0,1,.788.654,1.281,1.281,0,0,1,.191.671,1.528,1.528,0,0,1-.68,1.222,2.464,2.464,0,0,1-1.459.45,3.4,3.4,0,0,1-2.019-.789.418.418,0,0,1-.063-.575",
    transform: "translate(299.665 31.075)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3934",
    "data-name": "Path 3934",
    d: "M492.442,254.025a1.951,1.951,0,0,1,1.923-1.972,1.887,1.887,0,0,1,1.9,1.829v.039a.21.21,0,0,1-.008.071.38.38,0,0,1-.41.316H493.34a1.03,1.03,0,0,0,.268.52,1.222,1.222,0,0,0,.756.356,1.3,1.3,0,0,0,.822-.2.446.446,0,0,1,.59-.022.359.359,0,0,1,0,.512,1.993,1.993,0,0,1-1.413.521,1.956,1.956,0,0,1-1.923-1.971m.859-.387h2.232a1.29,1.29,0,0,0-1.168-.836,1.1,1.1,0,0,0-1.064.836",
    transform: "translate(299.945 31.487)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3935",
    "data-name": "Path 3935",
    d: "M499.595,253.693v1.886a.414.414,0,0,1-.409.417.427.427,0,0,1-.42-.417v-1.886a.808.808,0,0,0-.819-.8.786.786,0,0,0-.788.8v1.886a.142.142,0,0,1-.017.078.429.429,0,0,1-.418.339.416.416,0,0,1-.418-.417V252.47a.416.416,0,0,1,.418-.417.427.427,0,0,1,.387.245,1.575,1.575,0,0,1,.837-.245,1.651,1.651,0,0,1,1.648,1.64",
    transform: "translate(301.095 31.487)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    "data-name": "Path 3936",
    d: "M503.5,255.948a.428.428,0,0,1-.846.087,1.919,1.919,0,0,1-1.072.339,1.972,1.972,0,0,1,0-3.943,1.86,1.86,0,0,1,1.057.331v-1.483a.43.43,0,0,1,.86,0v4.669Zm-1.918-2.658a1.024,1.024,0,0,0-.742.323,1.125,1.125,0,0,0-.314.8,1.111,1.111,0,0,0,.314.781,1.024,1.024,0,0,0,.742.324,1.012,1.012,0,0,0,.743-.324,1.109,1.109,0,0,0,.314-.781,1.124,1.124,0,0,0-.314-.8,1.012,1.012,0,0,0-.743-.323",
    transform: "translate(299.223 31.111)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    d: "M510.439,251.288v4.653a.444.444,0,0,1-.442.433.432.432,0,0,1-.434-.433V252.62l-1.135,1.577a.428.428,0,0,1-.355.183h-.016a.443.443,0,0,1-.363-.183l-1.127-1.577v3.321a.438.438,0,0,1-.876,0v-4.653a.437.437,0,0,1,.434-.434h.024a.429.429,0,0,1,.347.182l1.569,2.176,1.571-2.176a.427.427,0,0,1,.354-.182H510a.449.449,0,0,1,.442.434",
    transform: "translate(301.123 31.111)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    d: "M510.478,254.025a1.952,1.952,0,0,1,1.926-1.972,1.888,1.888,0,0,1,1.9,1.829v.039a.193.193,0,0,1-.009.071.38.38,0,0,1-.411.316h-2.508a1.05,1.05,0,0,0,.268.52,1.226,1.226,0,0,0,.759.356,1.289,1.289,0,0,0,.819-.2.448.448,0,0,1,.592-.022.358.358,0,0,1,0,.512A1.994,1.994,0,0,1,512.4,256a1.957,1.957,0,0,1-1.926-1.971m.86-.387h2.232a1.292,1.292,0,0,0-1.167-.836,1.1,1.1,0,0,0-1.065.836",
    transform: "translate(302.634 31.487)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    "data-name": "Path 3939",
    d: "M514.22,254.868a.41.41,0,0,1,.592-.063,1.442,1.442,0,0,0,.867.347,1.077,1.077,0,0,0,.538-.149.324.324,0,0,0,.14-.238.122.122,0,0,0-.023-.079c-.007-.024-.04-.055-.1-.095a1.819,1.819,0,0,0-.63-.221h-.009a3.124,3.124,0,0,1-.687-.2,1.333,1.333,0,0,1-.545-.459.957.957,0,0,1-.133-.5,1.111,1.111,0,0,1,.464-.868,1.7,1.7,0,0,1,.972-.292,2.04,2.04,0,0,1,1.183.434.436.436,0,0,1,.126.584.42.42,0,0,1-.584.11,1.354,1.354,0,0,0-.725-.292.805.805,0,0,0-.475.142.239.239,0,0,0-.125.182.089.089,0,0,0,.015.063.219.219,0,0,0,.088.079,1.628,1.628,0,0,0,.575.189l.008.008h.008a2.79,2.79,0,0,1,.734.229,1.208,1.208,0,0,1,.559.464,1.011,1.011,0,0,1,.151.521,1.142,1.142,0,0,1-.5.915,1.792,1.792,0,0,1-1.026.314,2.284,2.284,0,0,1-1.4-.543.421.421,0,0,1-.055-.584",
    transform: "translate(303.786 31.486)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3940",
    "data-name": "Path 3940",
    d: "M517.112,254.868a.41.41,0,0,1,.592-.063,1.441,1.441,0,0,0,.867.347,1.076,1.076,0,0,0,.538-.149.323.323,0,0,0,.141-.238.119.119,0,0,0-.024-.079c-.006-.024-.039-.055-.1-.095a1.821,1.821,0,0,0-.63-.221h-.009a3.138,3.138,0,0,1-.687-.2,1.33,1.33,0,0,1-.544-.459.961.961,0,0,1-.132-.5,1.111,1.111,0,0,1,.464-.868,1.7,1.7,0,0,1,.973-.292,2.037,2.037,0,0,1,1.182.434.436.436,0,0,1,.126.584.42.42,0,0,1-.584.11,1.352,1.352,0,0,0-.725-.292.8.8,0,0,0-.475.142.238.238,0,0,0-.125.182.091.091,0,0,0,.015.063.224.224,0,0,0,.088.079,1.633,1.633,0,0,0,.575.189l.007.008h.008a2.8,2.8,0,0,1,.734.229,1.2,1.2,0,0,1,.559.464,1.007,1.007,0,0,1,.151.521,1.142,1.142,0,0,1-.5.915,1.793,1.793,0,0,1-1.026.314,2.282,2.282,0,0,1-1.4-.543.421.421,0,0,1-.055-.584",
    transform: "translate(304.696 31.486)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    d: "M523.624,254.032v1.547a.421.421,0,0,1-.419.417.428.428,0,0,1-.409-.339,1.784,1.784,0,0,1-1.05.339,1.835,1.835,0,0,1-1.341-.575,2.021,2.021,0,0,1-.537-1.389,2,2,0,0,1,.537-1.389,1.793,1.793,0,0,1,2.391-.243.428.428,0,0,1,.409-.347.424.424,0,0,1,.419.426Zm-.836,0a1.155,1.155,0,0,0-.308-.812.976.976,0,0,0-.734-.323.954.954,0,0,0-.734.323,1.155,1.155,0,0,0-.3.812,1.189,1.189,0,0,0,.3.813,1,1,0,0,0,.734.308,1.02,1.02,0,0,0,.734-.308,1.189,1.189,0,0,0,.308-.813",
    transform: "translate(305.598 31.487)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    d: "M527.7,254.048v1.466a1.9,1.9,0,0,1-1.894,1.892,1.829,1.829,0,0,1-.828-.2.417.417,0,0,1-.189-.567.427.427,0,0,1,.567-.2.94.94,0,0,0,.45.11,1.055,1.055,0,0,0,1.034-.844,1.815,1.815,0,0,1-2.373-.283,1.969,1.969,0,0,1-.553-1.389,2.064,2.064,0,0,1,.553-1.4,1.861,1.861,0,0,1,1.339-.584,1.79,1.79,0,0,1,1.057.331.425.425,0,0,1,.418-.331.416.416,0,0,1,.418.418v1.578Zm-.844-.009a1.221,1.221,0,0,0-.3-.8.983.983,0,0,0-.75-.339.947.947,0,0,0-.725.339,1.157,1.157,0,0,0-.316.8,1.138,1.138,0,0,0,.316.813.958.958,0,0,0,.725.323,1,1,0,0,0,.75-.323,1.2,1.2,0,0,0,.3-.813",
    transform: "translate(306.871 31.487)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    "data-name": "Path 3943",
    d: "M527.859,254.025a1.954,1.954,0,0,1,1.926-1.972,1.888,1.888,0,0,1,1.9,1.829v.039a.18.18,0,0,1-.01.071.378.378,0,0,1-.409.316h-2.51a1.051,1.051,0,0,0,.268.52,1.226,1.226,0,0,0,.759.356,1.288,1.288,0,0,0,.82-.2.449.449,0,0,1,.592-.022.36.36,0,0,1,0,.512,2,2,0,0,1-1.412.521,1.959,1.959,0,0,1-1.926-1.971m.86-.387h2.232a1.29,1.29,0,0,0-1.167-.836,1.1,1.1,0,0,0-1.066.836",
    transform: "translate(308.116 31.487)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3945",
    "data-name": "Path 3945",
    d: "M661.8,333.742c-5.209,81.574-99.439,112.024-158.293,87.59-51.173-21.253-34.424-69.749,8.766-77.862.023,0,.049-.012.072-.012,8.79-1.146,17.411-3.195,25.6-7.511,25.984-13.707,40.635-46.037,62.5-73.231,32.567-16.913,65.184,11.294,61.361,71.026",
    transform: "translate(312.601 46.153)",
    fill: "#001944",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3398",
    "data-name": "Rectangle 3398",
    width: 190.237,
    height: 171.665,
    transform: "translate(762.326 292.376)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3946",
    "data-name": "Path 3946",
    d: "M478.328,494.831c3.129-1.147,73.8-57.616,75.14-61.474.513-1.46-7.112-12.229-16.7-24.983-2.069-2.754-4.223-5.585-6.426-8.448-14.283-18.605-29.873-38.013-29.873-38.013l-47.387,37.638,31.177,36.977,6.837,8.122s-17.387,33.72-18.4,38.108,2.5,13.22,5.625,12.073",
    transform: "translate(287.87 65.251)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3947",
    "data-name": "Path 3947",
    d: "M473.664,485.723c3.13-1.147,73.8-57.616,75.139-61.474.617-1.781-10.767-17.31-23.123-33.431L479.6,427.42l6.838,8.122s-17.387,33.72-18.4,38.108,2.5,13.22,5.625,12.073",
    transform: "translate(292.465 74.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3948",
    "data-name": "Path 3948",
    d: "M473.664,483.7c3.13-1.147,73.8-57.616,75.139-61.474.513-1.46-7.112-12.229-16.7-24.982l-45.672,36.276s-17.387,33.72-18.4,38.108,2.5,13.22,5.625,12.073",
    transform: "translate(292.465 76.385)",
    fill: "#b4b6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3949",
    "data-name": "Path 3949",
    d: "M471.357,473.828c11.614-9.757,59.383-48.013,71.606-56.776.1-.071.151-.007.059.075-11.3,9.921-59.378,47.791-71.512,56.9-.255.192-.4.012-.154-.195",
    transform: "translate(293.59 82.618)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    "data-name": "Path 4007",
    d: "M469.917,449.8a12.184,12.184,0,0,1,9.4-2.771,11.806,11.806,0,0,1,7.7,4.208c.054.072-.075.179-.144.114a14.081,14.081,0,0,0-16.84-1.4.1.1,0,0,1-.118-.149",
    transform: "translate(294.059 92.037)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3950",
    "data-name": "Path 3950",
    d: "M479.238,429.826c4.69-3.855,11.525-6.575,17.571-5.051.234.059.147.391-.051.431a83.844,83.844,0,0,0-17.134,5.268.382.382,0,0,1-.385-.648",
    transform: "translate(296.724 84.923)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3951",
    "data-name": "Path 3951",
    d: "M477.323,433.135c4.69-3.855,11.525-6.574,17.571-5.051.234.059.147.391-.051.432a83.877,83.877,0,0,0-17.134,5.268.381.381,0,0,1-.385-.648",
    transform: "translate(296.168 85.97)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3952",
    "data-name": "Path 3952",
    d: "M475.407,436.443c4.69-3.855,11.525-6.574,17.571-5.051.234.059.147.392-.053.431a83.912,83.912,0,0,0-17.134,5.269.381.381,0,0,1-.384-.648",
    transform: "translate(295.614 87.011)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3995",
    "data-name": "Path 3995",
    d: "M473.491,439.752c4.69-3.854,11.525-6.574,17.571-5.051.234.059.147.392-.053.431a83.9,83.9,0,0,0-17.134,5.269.381.381,0,0,1-.384-.648",
    transform: "translate(295.057 88.052)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3953",
    "data-name": "Path 3953",
    d: "M517.1,410.6c5.333-4.235,11.926,4.043,6.584,8.285s-11.926-4.043-6.584-8.285",
    transform: "translate(304.1 80.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3954",
    "data-name": "Path 3954",
    d: "M473.578,429.582c5.2,1.256,10.758.218,16-.145a.74.74,0,0,0,.547-1.064.159.159,0,0,0,.039-.254,31.851,31.851,0,0,0-14-8.68c-3.132-.884-7.71-.411-8.52,3.5-.766,3.7,2.9,5.913,5.933,6.647m-3.359-3.752c-3.651-5.535,4.17-5.291,6.453-4.548a34.083,34.083,0,0,1,4.288,1.814,94.953,94.953,0,0,1,8.287,4.89c-2.586.02-5.148.262-7.73.378-3.079.138-9.286.519-11.3-2.533",
    transform: "translate(293.299 83.26)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3955",
    "data-name": "Path 3955",
    d: "M499.5,413.736c-2.847-2.8-6.914-.646-9.026,1.829a31.833,31.833,0,0,0-6.812,15,.16.16,0,0,0,.175.188.74.74,0,0,0,1.046.581c4.559-2.612,9.758-4.84,13.38-8.773,2.114-2.295,3.928-6.174,1.237-8.822m-8.514,12.222c-2.211,1.339-4.475,2.562-6.637,3.982a95.318,95.318,0,0,1,4.171-8.671,34.159,34.159,0,0,1,2.556-3.892c1.484-1.886,7.85-6.435,7.893.2.024,3.655-5.347,6.787-7.984,8.384",
    transform: "translate(298.062 81.168)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3956",
    "data-name": "Path 3956",
    d: "M416.77,345.841c3.248,24.614,63.92,95.668,70.931,103.816l1.6,1.856,50.188-38.559-.578-.746-44.2-57.853,131.826-.775-50.051-38.909s-4.061,2.341-12.5,1.109c-29.094-4.257-94.688-13.683-110.155-13.059-19.953.821-40.042,20.536-37.062,43.12",
    transform: "translate(272.977 46.588)",
    fill: "#4e6389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    "data-name": "Path 3957",
    d: "M463.917,325.629a59.06,59.06,0,0,1,4.56,5.842c1.561,2.048,3.149,4.076,4.708,6.124l.046.062c-.276-.6-.547-1.2-.835-1.8-.984-2.04-1.772-4.145-2.936-6.094a.108.108,0,0,1,.183-.113c1.2,1.936,2.586,3.776,3.61,5.813q.724,1.438,1.364,2.913c.233.541.472,1.081.681,1.631a7.971,7.971,0,0,1,.287.788c.7.951,1.389,1.907,2.06,2.878,1.488,2.156,2.8,4.433,4.308,6.57.08.116-.1.221-.184.113-1.525-2.011-3.235-3.885-4.785-5.88-1.577-2.031-3.074-4.118-4.551-6.222-1.442-2.052-2.853-4.126-4.294-6.18a61.367,61.367,0,0,1-4.346-6.347c-.041-.078.058-.168.125-.1",
    transform: "translate(292.275 54.328)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3958",
    "data-name": "Path 3958",
    d: "M512.067,379.931c-2.756,2.554-5.721,4.916-8.63,7.3s-5.851,4.762-8.8,7.12c-5.895,4.716-11.76,9.473-17.718,14.109-3.273,2.546-6.571,5.059-9.977,7.427-.151.106-.322-.137-.189-.258,5.581-5.074,11.535-9.712,17.423-14.418s11.813-9.414,17.783-14.04c3.266-2.532,6.517-5.139,9.932-7.467.138-.093.291.122.171.233",
    transform: "translate(292.709 70.849)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3959",
    "data-name": "Path 3959",
    d: "M527.017,304.372c.815.171,4.626.985,10.2,2.19,2.635-3.193,6.133-9.067,6.84-18.186.108-1.511,1.992,7.648-1.664,19.3,10.766,2.314,25.411,5.451,38.228,8.072,1.2-4.97,2.54-9.522,2.54-9.522a56.7,56.7,0,0,0,.245,10.1c1.751.372,3.473.7,5.12,1.036,1.1-7.859,5.011-21.176,5.011-21.176a69.719,69.719,0,0,0,2.284,22.626c8.153,1.577,13.547,2.467,13.276,2.015-9.656-16.492.931-22.924-.211-36.052-1.375-15.732-13.8-20.549-11.288-31.691,2.022-9.071,6.3-25.41-4.555-31.137,0,0-7.426-12.051-23.229-9.194-19.546,3.517-17.682,33.027-20.012,38.514-3.323,7.841-7.763,9.983-12.442,18.755-4.76,8.873-1.649,15.955-2.378,22.447-.752,6.482-10.005,11.492-7.961,11.9",
    transform: "translate(307.759 19.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    "data-name": "Path 4026",
    d: "M593.119,309.621a32.436,32.436,0,0,1-2.444-8.74c-.4-2.959.542-5.731,1.663-8.563a90.584,90.584,0,0,0,3.214-8.731,24.207,24.207,0,0,0,.885-9.565,21.254,21.254,0,0,0-3.376-9.028,56.631,56.631,0,0,0-5.876-7.282,34.471,34.471,0,0,1-5.344-7.232,16.658,16.658,0,0,1-1.72-8.777,15.6,15.6,0,0,0,.694,9.231,31.4,31.4,0,0,0,4.972,7.95,70.568,70.568,0,0,1,5.364,7.289,20.2,20.2,0,0,1,2.869,8.139,23.775,23.775,0,0,1-.76,8.664c-.723,2.888-1.825,5.72-2.793,8.675a30.875,30.875,0,0,0-1.179,4.591,13.667,13.667,0,0,0,.151,4.833,26.323,26.323,0,0,0,3.678,8.547",
    transform: "translate(324.48 28.216)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3960",
    "data-name": "Path 3960",
    d: "M558.161,219.122a46.58,46.58,0,0,0-4.548,10.417c-1.167,3.614-2.155,7.274-3.1,10.929l-1.447,5.45a27.952,27.952,0,0,1-1.836,5.121c-1.552,3.246-4.032,5.862-6.768,8.483a43.215,43.215,0,0,0-3.9,4.309,26.364,26.364,0,0,0-3.064,5.064,39.112,39.112,0,0,0-1.882,5.539,24.051,24.051,0,0,0-.78,5.825c-.03,1.963.165,3.865.278,5.713a28.709,28.709,0,0,1-.163,5.516,11.6,11.6,0,0,1-6.268,8.567A11.773,11.773,0,0,0,532.1,291.7a28.33,28.33,0,0,0,.6-5.763c.03-1.924-.1-3.794.037-5.605a30.044,30.044,0,0,1,2.865-10.459,26.068,26.068,0,0,1,2.851-4.565,40.962,40.962,0,0,1,3.742-4.039,57.276,57.276,0,0,0,3.951-4.219,23.546,23.546,0,0,0,3.186-5.011,30.2,30.2,0,0,0,1.818-5.576c.461-1.854.847-3.706,1.23-5.555.784-3.694,1.511-7.389,2.391-11.043a54.738,54.738,0,0,1,3.386-10.743",
    transform: "translate(307.114 21.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3961",
    "data-name": "Path 3961",
    d: "M594.177,272.844c-8.8,12.635-38.98,45.421-59.846,50.175-11.5,2.62-67.06,10.388-74.675,3.463-8.918-8.112-4.782-38.7,2.308-38.974,21.641-.85,61.689,3.384,71.693,1.176,4.525-1,28.511-16.464,54.125-28.837,9.686-4.679,12.075,4.844,6.394,13",
    transform: "translate(284.997 33.454)",
    fill: "#c95f50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3962",
    "data-name": "Path 3962",
    d: "M469.149,285.811l3.712,45.784s50.412-.8,65.632-9.352,39.991-30.373,49.47-45.537,6.308-23.434-12.193-14.109-43.478,24.293-46.749,25.084-59.871-1.87-59.871-1.87",
    transform: "translate(289.596 33.468)",
    fill: "#344c76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3963",
    "data-name": "Path 3963",
    d: "M475.311,281.753c0-.118.181-.166.207-.035.625,3.142.883,6.374,1.24,9.558.37,3.292.685,6.593.983,9.891.589,6.577,1.283,13.2,1.488,19.8a.207.207,0,1,1-.413.013c-.992-6.482-1.518-13.071-2.132-19.6-.3-3.237-.595-6.477-.828-9.72-.236-3.288-.588-6.609-.545-9.906",
    transform: "translate(295.832 40.647)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4461",
    "data-name": "Group 4461",
    transform: "translate(804.182 292.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4396",
    "data-name": "Group 4396",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M503.691,328.447c9.774-1.383,18.809-3.379,23.9-6.24,15.217-8.563,40-30.381,49.478-45.537,6.137-9.829,6.969-16.762,1.748-17.877Z",
    transform: "translate(-503.691 -258.794)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3996",
    "data-name": "Path 3996",
    d: "M615.236,362.679l-80.157-20.474,7.9-28.935s-6.343-9.078-3.646-17.727c2.407-7.713,20.685-30.66,24.377-33.716,6.333-5.245,17.654-7,23.854.312,25.554,30.125,27.668,100.54,27.668,100.54",
    transform: "translate(310.393 32.983)",
    fill: "#344c76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3997",
    "data-name": "Path 3997",
    d: "M592.142,267.907l-28.375-7.338c.145-.105.29-.224.434-.329l27.612,7.141c.106.171.224.342.329.526m6.143,11.494-41.78-10.81c-.105.118-.2.237-.3.355l42.305,10.942c-.079-.171-.158-.329-.223-.487m4.486,11.494-52.961-13.7c-.092.132-.184.25-.276.368l53.395,13.809-.158-.474m3.381,11.192-62.472-16.15a2.91,2.91,0,0,0-.237.368l62.827,16.255-.118-.473m2.631,11.034-69.9-18.083c-.039.132-.079.263-.105.395l70.115,18.149c-.039-.144-.066-.3-.105-.46m2.079,10.863-71.469-18.491a3.349,3.349,0,0,0,.157.473l71.391,18.465c-.026-.145-.052-.289-.079-.447m1.618,10.745L541.536,316.37l-.105.408,71.114,18.4c-.026-.145-.039-.29-.066-.447m1.237,10.653-74.824-19.346-.105.395,74.982,19.4c-.013-.145-.027-.289-.053-.447m.881,10.561-78.336-20.266-.105.408,78.468,20.306c-.013-.145-.013-.289-.027-.447",
    transform: "translate(310.736 33.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    "data-name": "Path 4008",
    d: "M550.126,296.961a78.857,78.857,0,0,1,10.625,4.805c1.685.95,3.316,1.97,4.933,3.03.808.529,1.626,1.027,2.452,1.524a12.449,12.449,0,0,0,2.718,1.306.07.07,0,0,1-.038.134,21.11,21.11,0,0,1-2.744-.79,20.493,20.493,0,0,1-2.5-1.2c-1.719-.946-3.394-1.971-5.1-2.934-3.448-1.945-6.9-3.888-10.477-5.579-.166-.078-.043-.362.129-.3",
    transform: "translate(315.078 45.443)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3998",
    "data-name": "Path 3998",
    d: "M542.407,297.6a85.353,85.353,0,0,1,9.4,2.042c1.548.434,3.057.954,4.562,1.519.718.268,1.432.551,2.141.842.782.32,1.521.744,2.305,1.052.083.033.047.164-.037.133-.75-.267-1.547-.413-2.311-.638s-1.532-.456-2.3-.683c-1.536-.451-3.077-.887-4.609-1.353-3.068-.934-6.13-1.833-9.228-2.661-.167-.045-.091-.28.073-.254",
    transform: "translate(312.654 45.648)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    "data-name": "Path 4027",
    d: "M573.07,266.915c-.481,1.44-8.4,10.342-15.1,9.4-2.181-.312-1.017-12.3-1.017-12.3l-.117-.9-1.618-12.659,15.443-7.99,2.221-1.041s.214,3.493.438,7.845c.012.2.022.4.032.619.02.246.041.477.047.708.042.65.082,1.314.108,1.975.021.5.045.993.049,1.523s.022,1.047.039,1.578a82.071,82.071,0,0,1-.52,11.241",
    transform: "translate(316.745 28.158)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4028",
    "data-name": "Path 4028",
    d: "M573.314,249.271a25.6,25.6,0,0,1-16.481,13.846l-1.618-12.659,15.441-7.99,2.221-1.041s.214,3.493.438,7.845",
    transform: "translate(316.746 28.168)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3999",
    "data-name": "Path 3999",
    d: "M543.531,236.456c-5.721,21.656,6.608,27.527,11.28,28.754,4.241,1.115,18.826,4.373,26.754-16.576s-.335-30.455-9.9-33.518-22.412-.317-28.133,21.34",
    transform: "translate(312.592 19.657)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M546.3,230.852a14.793,14.793,0,0,0,1.547-.03,2.5,2.5,0,0,0,1.572-.331.8.8,0,0,0,.18-.956,1.974,1.974,0,0,0-1.827-.818,2.907,2.907,0,0,0-1.982.667.851.851,0,0,0,.51,1.469",
    transform: "translate(313.685 24.229)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4029",
    "data-name": "Path 4029",
    d: "M558.453,232.662a14.275,14.275,0,0,1-1.427-.6,2.5,2.5,0,0,1-1.34-.886.8.8,0,0,1,.184-.955,1.975,1.975,0,0,1,2-.089,2.9,2.9,0,0,1,1.6,1.349.85.85,0,0,1-1.014,1.178",
    transform: "translate(316.868 24.599)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4021",
    "data-name": "Path 4021",
    d: "M554.8,234.754c.024-.054.1.1.087.157-.368,1.481-.54,3.239.7,4.023.04.025.019.1-.03.08-1.6-.584-1.345-2.916-.759-4.26",
    transform: "translate(316.474 26.102)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4022",
    "data-name": "Path 4022",
    d: "M556.431,233.787c2.438.333,1.592,5.183-.667,4.875-2.221-.3-1.376-5.154.667-4.875",
    transform: "translate(316.504 25.802)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4030",
    "data-name": "Path 4030",
    d: "M556.727,234.115c.376.349.706.9,1.208,1.044.581.162,1.117-.268,1.587-.689.049-.045.084.005.074.07-.149.933-.672,1.823-1.693,1.789-.931-.033-1.44-.969-1.509-1.944-.013-.181.182-.41.333-.27",
    transform: "translate(317.118 25.897)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M548.591,233.163c0-.059-.13.051-.138.114-.2,1.511-.689,3.21-2.134,3.482-.045.009-.052.084,0,.086,1.7.043,2.325-2.217,2.273-3.683",
    transform: "translate(313.929 25.605)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4011",
    "data-name": "Path 4011",
    d: "M547.792,231.806c-2.391-.586-3.387,4.235-1.173,4.778,2.178.535,3.177-4.286,1.173-4.778",
    transform: "translate(313.647 25.173)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4012",
    "data-name": "Path 4012",
    d: "M547.025,232.063c-.434.177-.906.563-1.368.5-.536-.074-.817-.676-1.051-1.245-.023-.059-.071-.026-.085.037-.216.917-.109,1.939.739,2.3.775.329,1.531-.339,1.941-1.213.076-.16,0-.447-.175-.376",
    transform: "translate(313.343 25.03)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4013",
    "data-name": "Path 4013",
    d: "M553.375,244.469c-.408.308-.832.75-1.387.726a4.045,4.045,0,0,1-1.578-.589.053.053,0,0,0-.075.07,2.056,2.056,0,0,0,1.815,1.067,1.621,1.621,0,0,0,1.362-1.186c.034-.084-.078-.131-.137-.087",
    transform: "translate(315.206 29.124)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4014",
    "data-name": "Path 4014",
    d: "M549.27,242.928s-.729,2.182-.925,3.238c-.018.1.227.193.582.281.018.009.025.017.041.009a5.108,5.108,0,0,0,5.228-.967c.093-.089-.02-.224-.131-.175a7.692,7.692,0,0,1-4.83.458c-.02-.305,1.37-3.694,1.206-3.738a9.4,9.4,0,0,0-2.5.1c1.381-4.588,3.489-8.916,4.8-13.506a.147.147,0,0,0-.264-.12c-2.529,4.381-4.234,9.627-5.786,14.327-.2.585,2.124.2,2.582.1",
    transform: "translate(314.053 24.135)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4015",
    "data-name": "Path 4015",
    d: "M548.906,242.07a5.551,5.551,0,0,0,1.735,2.207,2.5,2.5,0,0,0,1.447.458c1.133-.013,1.4-.981,1.417-1.865a5.986,5.986,0,0,0-.156-1.4,7.176,7.176,0,0,1-4.442.6",
    transform: "translate(314.757 28.196)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4016",
    "data-name": "Path 4016",
    d: "M550.226,243.95a2.5,2.5,0,0,0,1.447.459c1.133-.013,1.4-.982,1.416-1.866a2.575,2.575,0,0,0-2.862,1.407",
    transform: "translate(315.173 28.519)",
    fill: "#ff99ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    "data-name": "Path 4017",
    d: "M580.616,250.209a9.258,9.258,0,0,1-4.324-8.063,24.16,24.16,0,0,1-8.92-8.957c.1.476.813,3.919,1.233,5.662-13.877-4.211-17.065-15.535-17.065-15.535-5.1,4.077-6.343,6.908-7.169,8.3,0,0,.856-8.7,5.968-14.027a14.1,14.1,0,0,1,13.57-4.347,20.15,20.15,0,0,1,18.892,8.176c8.1,11.039-2.185,28.793-2.185,28.793",
    transform: "translate(313.326 19.297)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4018",
    "data-name": "Path 4018",
    d: "M556.443,233.374a26.289,26.289,0,0,0,6.973,3.471c.021.007.029-.024.009-.031a22.342,22.342,0,0,1-9.706-7.435,21.177,21.177,0,0,1-2.586-4.61,14.631,14.631,0,0,1-1.286-5.609.111.111,0,0,0-.221-.005,17.117,17.117,0,0,0,.508,5.706,15.624,15.624,0,0,0,2.63,5.037,17.985,17.985,0,0,0,3.679,3.476",
    transform: "translate(314.977 21.22)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    "data-name": "Path 4031",
    d: "M569.674,241.956s6.012-6.054,8.841-3.794-2.526,11.617-6.432,12.347a3.788,3.788,0,0,1-4.654-2.872Z",
    transform: "translate(320.601 27.003)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    "data-name": "Path 4032",
    d: "M576.436,240.055c.06,0,.056.089,0,.1-2.755.6-4.524,2.747-5.9,5.057a2.092,2.092,0,0,1,3.18-.029c.059.059-.024.154-.094.126a2.328,2.328,0,0,0-2.665.363,11.23,11.23,0,0,0-1.565,1.833c-.159.209-.554.014-.421-.235.011-.018.022-.037.032-.055.5-3.293,3.85-7.441,7.431-7.161",
    transform: "translate(321.079 27.748)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3964",
    "data-name": "Path 3964",
    d: "M597.623,276.372c6.32,35.842.211,62.689-5.88,66.014-16.395,8.95-55.759-9.2-66.865-12.811-4.49-1.459,15.971-35.78,20.553-33.664,10.795,4.986,25.92,13.453,26.529,13.389,1.217-.126,2.637-9.272,8.9-35.935,5.069-21.57,14.177-11.65,16.76,3.007",
    transform: "translate(306.975 34.135)",
    fill: "#c95f50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3965",
    "data-name": "Path 3965",
    d: "M497.534,275.686c-1.123,4.5,10.215,6.331,10.215,6.331a8.573,8.573,0,0,0-4.492,3.707c-1.65,3.117,2.517,7.071,2.517,7.071a10.554,10.554,0,0,0-4.116,4.664c-1.279,3.143,2.356,7.732,2.356,7.732a9.256,9.256,0,0,0-1.035,6.38c1.389,5.783,10.253,8.058,15.461,10.55,5.579,2.67,14.811,3.651,19,5.536l18.15-33.232s-17.534-18.559-27.541-21.438c-5.553-1.6-28.794-4.182-30.512,2.7",
    transform: "translate(298.527 37.368)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3966",
    "data-name": "Path 3966",
    d: "M505.408,279.344c6.31-.275,12.675.961,18.8,2.221a.108.108,0,0,1-.046.21c-6.08-1.323-12.66-1.053-18.781-2.132a.153.153,0,0,1,.023-.3",
    transform: "translate(300.989 39.963)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    "data-name": "Path 3967",
    d: "M504.035,287.294a16.39,16.39,0,0,1,4.232.788q2.216.572,4.413,1.218c2.931.861,5.842,1.788,8.727,2.8.126.045.089.251-.047.212-2.923-.854-5.859-1.661-8.815-2.391q-2.219-.546-4.446-1.059a19.541,19.541,0,0,1-4.15-1.16.218.218,0,0,1,.087-.409",
    transform: "translate(300.538 42.448)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3968",
    "data-name": "Path 3968",
    d: "M502.551,297.062a11.425,11.425,0,0,1,3.773.913q1.992.629,3.99,1.238c2.664.81,5.328,1.619,8.018,2.336.134.035.089.246-.046.212-2.738-.715-5.483-1.391-8.214-2.131q-2.013-.544-4.017-1.11a10.741,10.741,0,0,1-3.549-1.326.076.076,0,0,1,.046-.132",
    transform: "translate(300.109 45.481)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3969",
    "data-name": "Path 3969",
    d: "M545.735,295.692l-18.845,40.3s58.492,17.063,66.428,6.8,7.381-42.555,3.657-64.892S583.2,255.131,578.8,275.325s-6.993,32.943-7.784,32.83-25.279-12.462-25.279-12.462",
    transform: "translate(307.812 34.063)",
    fill: "#344c76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    d: "M551.052,291.425c.06-.1.241-.051.2.074-1.05,3.026-2.46,5.947-3.761,8.876-1.344,3.027-2.739,6.035-4.151,9.032-2.813,5.975-5.56,12.038-8.72,17.839-.137.253-.463.055-.363-.2,2.419-6.1,5.295-12.048,8.064-17.992,1.373-2.947,2.76-5.892,4.2-8.806,1.459-2.956,2.832-6,4.536-8.825",
    transform: "translate(310.129 43.674)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4019",
    "data-name": "Path 4019",
    d: "M550.407,337.339a25.236,25.236,0,0,1,4.9.818c1.688.3,3.382.567,5.083.79a96.633,96.633,0,0,0,9.93.851c3.268.085,11.352-.4,13.837-2.656a15.61,15.61,0,0,0,4.227-7.278,106.478,106.478,0,0,0,2.008-11.488,149.286,149.286,0,0,0,.767-24.608c-.092-2.285-.234-4.568-.4-6.848-.17-2.32-.443-4.653-.522-6.977a.08.08,0,0,1,.158-.017,83.248,83.248,0,0,1,1.548,11.267c.141-2.357.422-4.708.462-7.068a.106.106,0,0,1,.212.005c-.041,2.486.126,4.966.033,7.453-.052,1.4-.192,2.785-.349,4.17q.3,4.733.253,9.48c-.079,8.242-.7,16.767-2.9,24.743-.966,3.51-2.452,6.866-5.665,8.744a20.723,20.723,0,0,1-7.7,2.017,64.727,64.727,0,0,1-16.85-1.068q-2.335-.434-4.648-.967a18.392,18.392,0,0,1-4.433-1.218c-.075-.04-.03-.145.043-.148",
    transform: "translate(315.204 40.062)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    d: "M540.651,287.53l0,.009v0l0-.005",
    transform: "translate(312.151 42.525)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    d: "M540.848,290.282c-.05.184.09.48.2.309a6.766,6.766,0,0,0,.316-.61c4.086,2.388,8.349,4.544,12.579,6.66q3.269,1.638,6.568,3.21a63.082,63.082,0,0,0,6.447,2.843,61.034,61.034,0,0,0,1.7-6.107c.5-1.906.992-3.817,1.437-5.737.916-3.96,1.731-7.947,2.5-11.937.016-.078-.1-.116-.121-.036q-1.055,3.543-2.039,7.111a21.632,21.632,0,0,0,.026-4.356.042.042,0,0,0-.084,0c-.233,1.51-.366,3.066-.505,4.586-.087.946-.173,1.891-.264,2.837-.135.509-.282,1.015-.413,1.526-.507,1.965-.963,3.943-1.41,5.921-.41,1.814-1.154,4.629-1.2,5.6,0,0-3.881-2.091-5.911-3.139q-3.169-1.635-6.348-3.252c-4.283-2.193-8.6-4.358-12.908-6.51-.092-.046-.481.761-.57,1.086",
    transform: "translate(312.211 39.796)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    d: "M540.647,287.537h0",
    transform: "translate(312.151 42.528)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3399",
    "data-name": "Rectangle 3399",
    width: 83.4,
    height: 3.74,
    transform: "translate(770.573 361.836)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3970",
    "data-name": "Path 3970",
    d: "M543.695,311.775l2.855,3.74H478.141v-3.74Z",
    transform: "translate(295.644 50.061)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3971",
    "data-name": "Path 3971",
    d: "M546.377,327.84H465.1l-6.767-55.187H539.61Z",
    transform: "translate(289.592 37.833)",
    fill: "#b0afaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    "data-name": "Path 3972",
    d: "M497.931,294.819a4.844,4.844,0,0,1-4.861,4.946,5.054,5.054,0,0,1-5.034-4.946,4.844,4.844,0,0,1,4.861-4.946,5.053,5.053,0,0,1,5.034,4.946",
    transform: "translate(299.441 43.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    d: "M462.461,276.71c-3.063,4.728-10.625,10.257-11.666,14.313a4.8,4.8,0,0,0,1.98,5.378s-4.383,1.507-4.72,5.343c-.174,1.973,2.828,3.984,2.828,3.984s-3.46,1.361-3.548,4.791c-.071,2.731,2.947,4.337,2.947,4.337s-2.71,2.853-1.889,5.659c1.664,5.692,24.931,8.767,29.657.672,2.2-3.772-3.52-4.214-3.52-4.214s8.385-1.352,9.142-6.131-6.716-4.9-6.716-4.9,8.114-1.381,8.4-6.415c.3-5.24-7.2-4.086-7.2-4.086s5.637-2.824,4.973-6.727c-1.1-6.447-14.368.405-19.321-1.484Z",
    transform: "translate(287.208 39.1)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    "data-name": "Path 3974",
    d: "M449.929,305.961a.062.062,0,0,0-.039.117c7.407,2.875,16.425,3.765,24.157,1.739.254-.067.255-.508-.038-.488a83.374,83.374,0,0,1-24.08-1.368",
    transform: "translate(288.14 48.254)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3975",
    "data-name": "Path 3975",
    d: "M449.961,298.8c-.089-.02-.122.129-.032.163,7.648,2.922,17.834,3.644,26.47.259.3-.116.446-.517.095-.409-5.913,1.816-19.123,1.616-26.533-.013",
    transform: "translate(288.112 46.026)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    "data-name": "Path 3976",
    d: "M477.352,290.613c-8.407,2.926-16.9,2.863-25.625,1.544-.113-.017-.126.146-.036.186,4.09,1.807,9.736,2.069,14.147,1.9a23.462,23.462,0,0,0,11.617-3.337c.141-.084.078-.355-.1-.293",
    transform: "translate(288.633 43.476)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    d: "M333.017,408.419c1.158,3.125,57.869,73.6,61.73,74.923,1.463.509,12.21-7.151,24.935-16.773,2.749-2.078,5.574-4.24,8.431-6.452,18.564-14.339,37.925-29.988,37.925-29.988l-37.8-47.253-36.886,31.289-8.1,6.861s-33.785-17.273-38.176-18.269c-4.379-.98-13.215,2.538-12.058,5.663",
    transform: "translate(252.785 71.854)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    "data-name": "Path 3978",
    d: "M333.017,403.7c1.158,3.125,57.869,73.6,61.73,74.922,1.784.612,17.28-10.82,33.366-23.225l-36.76-45.952-8.1,6.861s-33.785-17.273-38.176-18.269c-4.379-.98-13.215,2.538-12.058,5.663",
    transform: "translate(253.318 76.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3979",
    "data-name": "Path 3979",
    d: "M333.017,403.7c1.158,3.125,57.869,73.6,61.73,74.922,1.463.509,12.21-7.151,24.935-16.773L383.251,416.3s-33.785-17.273-38.176-18.269c-4.379-.98-13.215,2.538-12.058,5.663",
    transform: "translate(253.433 76.58)",
    fill: "#b4b6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M335.821,401.372c9.8,11.58,48.216,59.213,57.021,71.4.071.1.007.151-.075.059-9.961-11.265-47.994-59.208-57.14-71.309-.192-.255-.012-.4.195-.155",
    transform: "translate(254.572 77.647)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    d: "M347.223,399.9a12.178,12.178,0,0,1,2.8,9.389A11.811,11.811,0,0,1,345.84,417c-.072.054-.179-.075-.116-.144a14.072,14.072,0,0,0,1.35-16.842.1.1,0,0,1,.149-.118",
    transform: "translate(258.154 77.209)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    "data-name": "Path 3982",
    d: "M367.646,409.151c3.87,4.677,6.613,11.5,5.109,17.551-.059.234-.391.147-.431-.051A83.929,83.929,0,0,0,367,409.538a.381.381,0,0,1,.647-.387",
    transform: "translate(264.311 80.094)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    "data-name": "Path 3983",
    d: "M364.331,407.247c3.872,4.675,6.613,11.5,5.109,17.55-.058.234-.391.147-.432-.051a83.855,83.855,0,0,0-5.325-17.113.381.381,0,0,1,.647-.387",
    transform: "translate(263.348 79.494)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    "data-name": "Path 3984",
    d: "M361.016,405.341c3.872,4.675,6.613,11.5,5.109,17.55-.058.234-.391.147-.431-.051a83.839,83.839,0,0,0-5.325-17.113.381.381,0,0,1,.647-.387",
    transform: "translate(262.384 78.893)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3985",
    "data-name": "Path 3985",
    d: "M357.7,403.435c3.871,4.675,6.613,11.5,5.109,17.551-.059.234-.391.147-.431-.051a83.919,83.919,0,0,0-5.325-17.113.381.381,0,0,1,.647-.387",
    transform: "translate(261.421 78.293)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4020",
    "data-name": "Path 4020",
    d: "M388.058,446.955c4.254,5.317-4.006,11.935-8.266,6.608s4.006-11.935,8.266-6.608",
    transform: "translate(267.639 91.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    "data-name": "Path 3986",
    d: "M369.052,403.49c-1.24,5.2-.184,10.755.195,15.995a.74.74,0,0,0,1.066.543.16.16,0,0,0,.255.039,31.841,31.841,0,0,0,8.636-14.025c.875-3.134.388-7.709-3.523-8.506-3.7-.754-5.905,2.917-6.629,5.954m3.741-3.371c5.525-3.668,5.307,4.152,4.57,6.436a34.259,34.259,0,0,1-1.8,4.293,95.468,95.468,0,0,1-4.865,8.3c-.029-2.586-.279-5.146-.4-7.728-.147-3.077-.548-9.281,2.5-11.3",
    transform: "translate(264.689 76.447)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    "data-name": "Path 3987",
    d: "M386.882,429.349c2.789-2.854.623-6.912-1.859-9.017A31.843,31.843,0,0,0,370,413.572a.159.159,0,0,0-.188.174.741.741,0,0,0-.578,1.048c2.628,4.55,4.873,9.74,8.819,13.349,2.3,2.106,6.189,3.906,8.828,1.206m-12.252-8.471c-1.347-2.207-2.577-4.466-4-6.622a95.776,95.776,0,0,1,8.686,4.142,34.1,34.1,0,0,1,3.9,2.543c1.891,1.477,6.463,7.826-.169,7.891-3.656.035-6.808-5.325-8.413-7.954",
    transform: "translate(264.787 81.53)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3988",
    "data-name": "Path 3988",
    d: "M378.839,432.028l39.337,53.059L550.914,393l12.8-8.884s3.624,2.438,9.081,5.454c7.577,4.189,18.682,9.491,28.506,10.938,16.479,2.438,41.328,2.176,55.217-16.392,11.7-15.634,8.009-36.032,8.009-36.032l-18.093-7.767s-42.817-35.667-70.553-36.741c-11.78-.468-28.934,8.458-44.821,17.784s-152.22,110.665-152.22,110.665",
    transform: "translate(261.106 46.861)",
    fill: "#667ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3989",
    "data-name": "Path 3989",
    d: "M519.377,371.477s3.624,2.438,9.08,5.455c9.645-11.544,30.064-32.509,30.684-33.253Z",
    transform: "translate(305.44 59.929)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    "data-name": "Path 4033",
    d: "M570.349,322.436c2.56,1.777,5.036,3.664,7.56,5.488,2.484,1.8,5.049,3.48,7.409,5.438,2.4,1.992,4.678,4.119,6.939,6.267,1.092,1.035,2.174,2.079,3.229,3.151a29.556,29.556,0,0,1,3.082,3.346c.082.113-.082.247-.188.179a34.909,34.909,0,0,1-3.431-2.791c-1.2-1.007-2.383-2.03-3.575-3.044-2.3-1.956-4.648-3.857-6.944-5.818-2.281-1.949-4.394-4.082-6.652-6.055-2.418-2.112-4.968-4.078-7.48-6.077-.047-.038,0-.12.051-.083",
    transform: "translate(321.498 53.344)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    "data-name": "Path 3990",
    d: "M387.923,398.172c2.456,2.843,4.712,5.889,6.989,8.879s4.554,6.014,6.806,9.039c4.508,6.055,9.056,12.083,13.48,18.2,2.431,3.36,4.827,6.743,7.074,10.229.1.155-.149.318-.266.18-4.875-5.754-9.3-11.867-13.8-17.915s-8.994-12.135-13.409-18.262c-2.415-3.353-4.908-6.693-7.114-10.187-.089-.141.132-.284.238-.162",
    transform: "translate(269.961 76.662)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3991",
    "data-name": "Path 3991",
    d: "M462.483,414.415c6.6-5.2,21.62-15.364,28.467-20.244,6.813-4.855,13.622-9.725,20.536-14.435,1.986-1.352,3.989-2.676,5.989-4.006s4.074-2.553,6.03-3.93c.114-.08.216.109.1.188-1.8,1.288-3.492,2.732-5.258,4.068-1.685,1.276-3.357,2.567-5.057,3.824-3.316,2.454-6.665,4.863-10.009,7.279q-10.172,7.352-20.515,14.474c-3.919,2.687-15.986,10.632-19.99,13.186-.239.153-.524-.226-.3-.4",
    transform: "translate(291.211 68.36)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3992",
    "data-name": "Path 3992",
    d: "M430.818,379.636c6.1-5.057,20.016-14.777,26.412-19.451,6.469-4.729,12.907-9.5,19.4-14.2l19.332-13.972c6.247-4.514,12.464-9.1,19.061-13.1,3.611-2.188,7.314-4.215,11.121-6.042a72.841,72.841,0,0,1,11.493-4.694.108.108,0,0,1,.079.2c-3.253,1.816-6.67,3.344-9.959,5.1q-4.88,2.6-9.61,5.466c-6.55,3.97-12.735,8.479-18.948,12.946-12.9,9.277-25.781,18.594-38.776,27.742-7.272,5.12-21.767,15.7-29.318,20.4-.237.147-.508-.216-.291-.4",
    transform: "translate(281.322 48.824)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773",
    "data-name": "Path 3773",
    d: "M216.106,160.228a.519.519,0,0,1-.354.587c-.588.109-1.3.231-2.089.371-2.428-4.7-4.894-8.371-4.192-6.908a25.387,25.387,0,0,1,2.139,7.264c-.922.155-3.061.5-4.132.667-2.593-8.459-5.4-14.632-5.053-12.67,1.411,7.916,1.225,10.532.973,13.332-9.974,1.58-23.072,3.507-32.57,4.7-1.63-4.653-3.164-9.716-3.291-9.336-1,2.845-.916,6.8-.609,9.816-3.027.358-5.453.588-6.938.654,0,0-1.154-3.936-1.4-5.246a27.784,27.784,0,0,1-.055-10.179,49.963,49.963,0,0,1,3.364-9.825.308.308,0,0,1,.033-.07c0-.009.005-.014.01-.028a28.535,28.535,0,0,0,1.839-6.511.151.151,0,0,0,.012-.05,27.609,27.609,0,0,0,.251-4.873c-.213-5.947,2.544-11.419,7.915-13.595,9.377-11.025,20.328-8.049,24.335-.839.387.7.777,1.515,1.168,2.405l.011.028c1.451,3.289,2.9,7.606,4.17,10.926a.014.014,0,0,0,.007.018c0,.013,0,.022.016.037l0,.009a32.553,32.553,0,0,0,1.681,3.811c3.328,5.859,9.762,8.68,12.758,25.507",
    transform: "translate(203.228 -12.317)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774",
    "data-name": "Path 3774",
    d: "M170.086,118.032a11.219,11.219,0,0,0-5.438,9.69,28.951,28.951,0,0,1-.645,7.49,26.123,26.123,0,0,1-3.473,6.919c-2.218,3.469-3.66,6.839-3.59,11.108.071,4.337.839,9.377,2.731,13.219a.019.019,0,0,0,.034-.016,34.6,34.6,0,0,1-2.028-13.877c.276-4.76,2.6-7.994,4.907-11.846a19.62,19.62,0,0,0,2.919-9.978c.034-2.158-.243-4.369.391-6.469.756-2.507,2.627-4.256,4.5-5.833a.255.255,0,0,0-.307-.406",
    transform: "translate(203.222 -10.171)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775",
    "data-name": "Path 3775",
    d: "M200.761,138.524c-2.939-3.056-5.928-5.608-7.893-9.59-1.789-3.627-3.016-7.536-4.83-11.156a.049.049,0,1,0-.089.039c2.894,6.465,4.061,13.186,9.018,18.341,2.694,2.8,5.362,5.378,7.322,8.879a32.978,32.978,0,0,1,3.785,11.855.1.1,0,1,0,.206-.025,27.267,27.267,0,0,0-7.518-18.342",
    transform: "translate(212.172 -10.251)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776",
    "data-name": "Path 3776",
    d: "M171.985,120.033c1.543-.355,4.016-8.385-.872-13.005-4.813-4.55-12.392-1.059-10.373,6.052,1.277,4.494,7.981,7.705,11.245,6.953",
    transform: "translate(204.23 -12.864)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777",
    "data-name": "Path 3777",
    d: "M164.1,105.417a9.275,9.275,0,0,0-3.8,4.8,5.591,5.591,0,0,0,.945,5.506,11.3,11.3,0,0,0,5.022,3.327,17.2,17.2,0,0,0,3.032.783,8.543,8.543,0,0,0,3.156.064,7.5,7.5,0,0,1-3.208.512A13.973,13.973,0,0,1,166,119.93a10.9,10.9,0,0,1-5.666-3.467,6.223,6.223,0,0,1-.884-6.572,8.186,8.186,0,0,1,4.657-4.474",
    transform: "translate(203.789 -12.722)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3778",
    "data-name": "Path 3778",
    d: "M184.969,148.168c17.9,18.759,40.159,54.284,35.757,62.083-4.9,8.685-30.718-18.016-29.907-19.3.688-1.086-8.231-21.015-14.711-38.277-6.473-17.247,4.434-9.148,8.861-4.51",
    transform: "translate(207.948 -2.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    d: "M207.069,170.658l-25.7,4.627s-6.417-18.208-7.689-28.319c-.714-5.666,2.617-5.9,6.808-2.887,14.665,10.538,26.586,26.579,26.586,26.579",
    transform: "translate(207.904 -2.675)",
    fill: "#667ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780",
    "data-name": "Path 3780",
    d: "M179.636,165.174a172.878,172.878,0,0,1,21.676-4.281c.044-.005.079.155.038.167-5.843,1.5-17.69,3.655-21.662,4.353-.075.013-.126-.22-.053-.239",
    transform: "translate(209.74 3.134)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4457",
    "data-name": "Group 4457",
    transform: "translate(381.525 139.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4401",
    "data-name": "Group 4401",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M201.589,171.646l-20.225,3.638s-6.413-18.208-7.686-28.315c-.459-3.626.743-5.026,2.766-4.777Z",
    transform: "translate(-173.58 -142.163)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781",
    "data-name": "Path 3781",
    d: "M206.691,209.4h-57.2s2.642-37.225,19.318-61.633c4.84-7.082,14.176-6.472,19.034-2.109,1.211,1.09,17.663,22.563,18.336,26.245,1.113,6.084-4.274,12.66-4.274,12.66Z",
    transform: "translate(200.745 -2.581)",
    fill: "#667ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3782",
    "data-name": "Path 3782",
    d: "M173.411,171.7a61.091,61.091,0,0,1,9.016.819c1.477.267,2.934.6,4.39.965.726.182,1.454.339,2.185.493a9.636,9.636,0,0,0,2.327.266.054.054,0,0,1,.007.108,16.369,16.369,0,0,1-2.214.12,15.974,15.974,0,0,1-2.136-.245c-1.5-.256-2.991-.583-4.49-.854-3.024-.548-6.047-1.094-9.1-1.423-.141-.015-.122-.254.02-.25",
    transform: "translate(207.938 6.497)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783",
    "data-name": "Path 3783",
    d: "M167.913,174.359a66.274,66.274,0,0,1,7.417-.9c1.246-.075,2.486-.078,3.733-.047.595.014,1.189.039,1.784.071.655.036,1.3.159,1.959.185.068,0,.076.108.007.108-.618-.007-1.239.09-1.856.12s-1.24.055-1.861.086c-1.242.059-2.482.133-3.724.181-2.488.095-4.963.216-7.446.4-.134.011-.138-.181-.012-.2",
    transform: "translate(206.373 7.022)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3784",
    "data-name": "Path 3784",
    d: "M221.385,199.854c-2.522,4.6-15.39,3.681-42.291,2.559-3.723-.155-9.694-26.713-5.71-26.753,5.019-.049,24.5.851,25.917,1.1,11.947,2.071,24.3,19.058,22.084,23.1",
    transform: "translate(207.338 7.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3785",
    "data-name": "Path 3785",
    d: "M188.262,175.786s-11.28-.963-17.363.366a40.023,40.023,0,0,0-16.962,8.876c-5.253,4.608-14.765,19.383-10.987,22.864,3.42,3.151,12.381-12.441,12.381-12.441s-11.76,14.39-6.944,17.428,14.187-15.654,14.187-15.654-11.751,15.057-6.289,17.4c4.128,1.773,13.569-14.678,13.569-14.678s-10.011,13.012-5.845,15.019c4.6,2.217,14.273-12.422,14.273-12.422,11.45,3.319,18.259.217,22.841-2.566,1.109-.675-12.861-24.2-12.861-24.2",
    transform: "translate(198.591 7.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3786",
    "data-name": "Path 3786",
    d: "M157.768,186.678c-1.443,1.64-2.914,3.292-4.206,5.054s-2.523,3.573-3.645,5.447a37.273,37.273,0,0,0-3.67,7.713c1.993-4.677,6.518-11.059,7.811-12.823s2.49-3.584,3.778-5.345c.033-.045-.034-.087-.068-.047",
    transform: "translate(200.129 11.149)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3787",
    "data-name": "Path 3787",
    d: "M162.253,190.135c-1.751,2.174-3.57,4.269-5.226,6.522s-3.014,4.511-4.5,6.861c-.115.18.02.183.142.005,1.582-2.287,3.22-4.281,4.829-6.549s3.129-4.6,4.813-6.8c.026-.035-.029-.071-.055-.038",
    transform: "translate(201.954 12.227)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3788",
    "data-name": "Path 3788",
    d: "M166.393,192.348a62.3,62.3,0,0,0-7.227,10.583c-.106.183.068.167.188-.015,2.336-3.563,4.142-6.374,7.151-10.47.046-.063-.051-.166-.112-.1",
    transform: "translate(203.904 12.911)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3789",
    "data-name": "Path 3789",
    d: "M204.631,181.424c-2.174-1.653-8.383-5.63-14.86-5.222a.057.057,0,0,0-.007.113c5.271.421,12.569,3.769,14.807,5.2.058.038.113-.047.059-.089",
    transform: "translate(212.73 7.886)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3790",
    "data-name": "Path 3790",
    d: "M179.076,154.022c-9.332,21.015-34.114,52.915-43.063,52.528-9.966-.431,3.643-27.037,4.463-28.31,4.612-7.15,16.708-19.308,30.034-29.3,11.189-8.389,11.168-.78,8.566,5.08",
    transform: "translate(195.858 -1.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3791",
    "data-name": "Path 3791",
    d: "M135.962,203.888c-5.2-3.219-5.7-15.475-9.253-43.608-.491-3.893,25.627-11.117,26.366-6.987.93,5.2,1.346,23.3,1.339,24.809-.057,12.77-14.326,28.339-18.452,25.786",
    transform: "translate(194.348 0.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3792",
    "data-name": "Path 3792",
    d: "M128.045,168.29c-1.033-2.966-4.712-17.123-4.824-21.242s.426-15.992,3.572-16.4,3.266,3.083,3.266,3.083,1.022-4.978,4.225-5.1,3.212,5.313,3.212,5.313,1.422-5.036,4.627-4.927,2.3,5.574,2.3,5.574,1.085-4.665,3.687-3.464c3.13,1.444.158,9.818.622,14.355.105,1.031,3.624,20.731,3.624,20.731Z",
    transform: "translate(193.328 -6.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3793",
    "data-name": "Path 3793",
    d: "M139.981,132.879c-2.172,6.163-2.055,9.235-.622,15.507.027.122-.149.192-.19.066-1.961-6.013-2.664-9.845.518-15.694.155-.285.4-.172.293.121",
    transform: "translate(197.649 -5.659)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3794",
    "data-name": "Path 3794",
    d: "M134.709,132.362c-1.7,6.6-1.6,9.932-.583,16.61.014.095-.143.129-.166.034-1.546-6.468-2.159-10.307.4-16.677.116-.288.424-.27.346.033",
    transform: "translate(196.232 -5.804)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    "data-name": "Path 3795",
    d: "M128.841,132.842c-1.181,6.507-1.233,10.166.588,16.523a.122.122,0,0,1-.23.08c-2.485-6.3-2.456-10.868-.559-16.618.129-.393.275-.395.2.014",
    transform: "translate(194.676 -5.676)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3796",
    "data-name": "Path 3796",
    d: "M149.768,165.6s3.677-7.316,4.582-10.887-.617-18.119-3.778-17.968c-4.083.193-4.858,8.765-4.69,13.013,0,0-9.442.441-11.33,6.472s15.216,9.369,15.216,9.369",
    transform: "translate(196.634 -4.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    d: "M149.5,137.075c-3.594,2.862-3.012,8.423-3.157,12.557a.378.378,0,0,1-.506.359c-3.945.45-9.381,2.232-11.372,5.918a.1.1,0,0,1-.175-.076c1.6-4.244,6.794-6.431,11.147-6.645.083-4.24-.255-9.844,4.037-12.148a.022.022,0,0,1,.026.036",
    transform: "translate(196.631 -4.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    d: "M147.843,160.1c.293,2.221.492,4.45.659,6.682s.255,4.47.309,6.713a26.863,26.863,0,0,1-.609,6.726,23.448,23.448,0,0,1-2.34,6.3,31.234,31.234,0,0,0,1.846-6.4,30.441,30.441,0,0,0,.421-3.286c.051-1.1.049-2.216.025-3.33-.029-4.46-.279-8.924-.31-13.4",
    transform: "translate(200.076 2.895)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M162.313,183.773l-13.686-22.239s14.616-12.616,23.568-17.489c5.017-2.73,6.449.284,5.172,5.283-4.463,17.5-15.054,34.445-15.054,34.445",
    transform: "translate(200.699 -2.404)",
    fill: "#667ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    d: "M151.7,156.052a173.03,173.03,0,0,1,11.9,18.616c.02.038-.117.13-.142.1-3.531-4.891-9.859-15.133-11.958-18.575-.04-.064.159-.2.2-.137",
    transform: "translate(201.65 1.631)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M157.321,175.011c.374.651,1.907,3.054,2.3,3.636.762-1.552,1.546-2.889,2.363-4.412q1.371-2.557,2.67-5.153c1.763-3.518,3.41-7.094,5.078-10.658.036-.078.158-.042.129.043-.713,2.067-1.522,4.1-2.392,6.1.524-.777,1.031-1.566,1.515-2.371.028-.047.095,0,.07.047a28.3,28.3,0,0,1-1.938,3.12c-.58,1.307-1.18,2.607-1.81,3.893q-1.241,2.527-2.591,4.995a47.349,47.349,0,0,1-3.01,5.105,42.711,42.711,0,0,1-2.531-4.27c-.051-.1.1-.171.151-.076",
    transform: "translate(203.291 2.361)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M172.409,141.911c-4.429,1.726-3.56,6.7.256,10.888s8.41,4.744,10.545,3.855,3.556-3.83.164-9.039c-4.32-6.638-8.289-6.747-10.966-5.7",
    transform: "translate(206.832 -2.915)",
    fill: "#3a5686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M170.741,148.838c.205,1.092,5.049,8.33,10,8.317,1.611-.007,1.967-8.8,1.967-8.8l.175-.643,2.439-9-10.383-7.331-1.5-.976s-.505,2.508-1.1,5.637c-.028.145-.057.291-.086.446-.038.176-.076.342-.1.508-.1.467-.191.943-.276,1.42-.066.362-.132.714-.187,1.1s-.122.756-.187,1.139a60.044,60.044,0,0,0-.749,8.192",
    transform: "translate(207.218 -6.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    "data-name": "Path 3804",
    d: "M171.945,136.038a18.719,18.719,0,0,0,10.55,11.675l2.439-9.006-10.383-7.329-1.5-.976s-.505,2.508-1.1,5.637",
    transform: "translate(207.584 -6.338)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M197.946,129.831c2.934,16.109-6.385,19.684-9.861,20.312-3.154.571-13.969,2.113-18.552-13.607s1.981-22.175,9.128-23.862,16.351,1.047,19.285,17.156",
    transform: "translate(206.313 -11.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    d: "M186.587,123.755a10.4,10.4,0,0,1-1.129-.074,1.831,1.831,0,0,1-1.137-.293.583.583,0,0,1-.1-.7,1.447,1.447,0,0,1,1.362-.537,2.125,2.125,0,0,1,1.426.552.622.622,0,0,1-.421,1.056",
    transform: "translate(211.206 -8.916)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3807",
    "data-name": "Path 3807",
    d: "M178.081,125.221a10.44,10.44,0,0,0,1.062-.389,1.827,1.827,0,0,0,1.009-.6.583.583,0,0,0-.1-.7,1.447,1.447,0,0,0-1.458-.132,2.12,2.12,0,0,0-1.211.932.621.621,0,0,0,.7.894",
    transform: "translate(209.212 -8.57)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3808",
    "data-name": "Path 3808",
    d: "M180.181,127.476c-.017-.039-.074.07-.063.115.271,1.082.4,2.367-.509,2.942-.028.018-.013.072.022.059,1.167-.43.98-2.133.55-3.116",
    transform: "translate(209.897 -7.261)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3809",
    "data-name": "Path 3809",
    d: "M179.371,126.771c-1.782.246-1.158,3.79.493,3.563,1.625-.225,1-3.769-.493-3.563",
    transform: "translate(209.509 -7.479)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3810",
    "data-name": "Path 3810",
    d: "M179.112,127.013c-.275.255-.516.663-.883.764-.424.12-.816-.195-1.16-.5-.036-.033-.062,0-.054.051.109.681.493,1.331,1.239,1.3.681-.025,1.052-.71,1.1-1.423.009-.132-.133-.3-.243-.2",
    transform: "translate(209.138 -7.414)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3811",
    "data-name": "Path 3811",
    d: "M184.97,126.409c0-.043.093.042.1.088.1,1.11.4,2.367,1.443,2.615.032.007.035.063,0,.062-1.243-.025-1.623-1.7-1.538-2.764",
    transform: "translate(211.452 -7.595)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    "data-name": "Path 3812",
    d: "M185.818,125.443c1.764-.348,2.334,3.205.7,3.529-1.609.318-2.177-3.235-.7-3.529",
    transform: "translate(211.446 -7.898)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    "data-name": "Path 3813",
    d: "M186.243,125.642c.31.143.643.442.983.409.393-.035.618-.467.808-.875.021-.042.053-.017.062.029.128.677.016,1.42-.616,1.656-.576.213-1.108-.3-1.377-.95-.05-.121.016-.327.141-.27",
    transform: "translate(211.775 -7.981)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    "data-name": "Path 3814",
    d: "M181.114,134.107c.287.238.583.575.988.575a2.927,2.927,0,0,0,1.172-.377.039.039,0,0,1,.053.054,1.5,1.5,0,0,1-1.36.718,1.185,1.185,0,0,1-.955-.91c-.022-.063.061-.093.1-.059",
    transform: "translate(210.299 -5.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    "data-name": "Path 3815",
    d: "M185.432,132.961s.462,1.626.571,2.407a4.251,4.251,0,0,1-4.271-.689c-.072-.062.024-.164.1-.125a5.657,5.657,0,0,0,3.529.5c.025-.224-.883-2.755-.76-2.783a6.867,6.867,0,0,1,1.831.154c-.863-3.413-2.265-6.659-3.073-10.069a.108.108,0,0,1,.2-.079,56.9,56.9,0,0,1,3.771,10.7c.126.435-1.565.074-1.9-.016",
    transform: "translate(210.477 -8.886)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    d: "M184.979,132.468a4.074,4.074,0,0,1-1.468,1.452,1.826,1.826,0,0,1-1.1.2c-.826-.113-.935-.844-.864-1.49a4.368,4.368,0,0,1,.241-1.006,5.279,5.279,0,0,0,3.189.84",
    transform: "translate(210.441 -5.969)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    d: "M183.511,133.68a1.835,1.835,0,0,1-1.1.2c-.826-.113-.935-.844-.865-1.491a1.9,1.9,0,0,1,1.963,1.287",
    transform: "translate(210.451 -5.73)",
    fill: "#667ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3818",
    "data-name": "Path 3818",
    d: "M171.394,138.327c4.045-.8,3.22-13.484,3.1-15.041.125.976.809,6.146,1.235,6.288a3.973,3.973,0,0,0,1.238-.446l.009,0a12.432,12.432,0,0,1-.147-1.865c-.013-.291.208.6.542,1.689.22-.1.456-.217.717-.33a15.031,15.031,0,0,1-.239-3.974c.041-.5.521,1.662,1.293,3.5a49.73,49.73,0,0,1,10.348-3.585c1.008-.2,1.885-.329,2.666-.416-.238-1.52-.674-3.11-.505-2.78a14.926,14.926,0,0,1,1.088,2.721c.422-.043.817-.076,1.169-.1-.239-2.163-1.81-5.424-1.381-4.954a15.289,15.289,0,0,1,2.919,4.95c1.512.049,1.961.271,1.94-.116a18.122,18.122,0,0,0-7.225-10.219c-5.853-3.969-16.187-3.546-20.721,4.744,0,0-4.215,3.828-4.162,8.9s3.777,11.5,6.114,11.041",
    transform: "translate(205.508 -12.294)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    "data-name": "Path 3819",
    d: "M172.94,131.738s-4.036-4.754-6.226-3.269,1.177,8.61,3.983,9.365a2.769,2.769,0,0,0,3.556-1.828Z",
    transform: "translate(205.894 -7.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    d: "M167.326,129.935a.037.037,0,0,0-.008.074c1.973.592,3.14,2.261,4.012,4.022a1.53,1.53,0,0,0-2.316-.2c-.046.041.008.113.061.1a1.705,1.705,0,0,1,1.923.417,8.226,8.226,0,0,1,1.035,1.425c.1.162.4.042.32-.148-.005-.013-.013-.028-.02-.042-.179-2.428-2.381-5.642-5.007-5.642",
    transform: "translate(206.291 -6.493)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    d: "M171.046,135.012a.664.664,0,1,1-.676-.652.664.664,0,0,1,.676.652",
    transform: "translate(207.023 -5.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M169.7,134.166a.48.48,0,1,1-.488-.471.48.48,0,0,1,.488.471",
    transform: "translate(206.741 -5.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M166.853,130l-.988-.067a.35.35,0,0,1-.325-.372h0a.351.351,0,0,1,.374-.325l.985.066a.351.351,0,0,1-.046.7",
    transform: "translate(205.806 -6.714)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M166.911,130.758l-.979.143a.35.35,0,1,1-.1-.693l.979-.143a.35.35,0,1,1,.1.693",
    transform: "translate(205.803 -6.458)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4462",
    "data-name": "Group 4462",
    transform: "translate(480.789 280.398)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3358",
    "data-name": "Rectangle 3358",
    width: 125.905,
    height: 2.209,
    transform: "translate(12.149 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3363",
    "data-name": "Rectangle 3363",
    width: 196.588,
    height: 2.209,
    transform: "translate(0 87.25)",
    fill: "#ebebeb",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3366",
    "data-name": "Rectangle 3366",
    width: 196.588,
    height: 2.209,
    transform: "translate(0 114.861)",
    fill: "#ebebeb",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3367",
    "data-name": "Rectangle 3367",
    width: 196.588,
    height: 1.104,
    transform: "translate(0 164.56)",
    fill: "#ebebeb",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3359",
    "data-name": "Rectangle 3359",
    width: 125.905,
    height: 2.209,
    transform: "translate(12.149 8.836)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3362",
    "data-name": "Rectangle 3362",
    width: 196.588,
    height: 2.209,
    transform: "translate(0 96.086)",
    fill: "#ebebeb",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3369",
    "data-name": "Rectangle 3369",
    width: 196.588,
    height: 2.209,
    transform: "translate(0 145.785)",
    fill: "#ebebeb",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3365",
    "data-name": "Rectangle 3365",
    width: 149.098,
    height: 2.209,
    transform: "translate(0 124.801)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3371",
    "data-name": "Rectangle 3371",
    width: 149.098,
    height: 2.209,
    transform: "translate(0 174.5)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3360",
    "data-name": "Rectangle 3360",
    width: 125.905,
    height: 1.104,
    transform: "translate(12.149 18.775)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3361",
    "data-name": "Rectangle 3361",
    width: 196.588,
    height: 1.104,
    transform: "translate(0 106.025)",
    fill: "#ebebeb",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3368",
    "data-name": "Rectangle 3368",
    width: 196.588,
    height: 1.104,
    transform: "translate(0 155.725)",
    fill: "#ebebeb",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3364",
    "data-name": "Rectangle 3364",
    width: 149.098,
    height: 1.104,
    transform: "translate(0 133.636)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3370",
    "data-name": "Rectangle 3370",
    width: 149.098,
    height: 2.209,
    transform: "translate(0 182.231)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("text", {
    id: "About",
    transform: "translate(484.061 347.364)",
    fill: "#bbb",
    fontSize: 1,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "About")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3379",
    "data-name": "Rectangle 3379",
    width: 45.814,
    height: 25.073,
    transform: "translate(88.086 471.489)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3380",
    "data-name": "Rectangle 3380",
    width: 94.453,
    height: 114.543,
    transform: "translate(160.241 163.996)",
    fill: "none",
    stroke: "#bfc8da",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3381",
    "data-name": "Rectangle 3381",
    width: 72.868,
    height: 93.635,
    transform: "translate(170.895 174.407)",
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3382",
    "data-name": "Rectangle 3382",
    width: 14.719,
    height: 37.208,
    transform: "translate(199.927 198.52)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3383",
    "data-name": "Rectangle 3383",
    width: 39.542,
    height: 25.65,
    transform: "translate(187.356 221.057)",
    fill: "none",
    stroke: "#dbdbdb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    "data-name": "Path 3840",
    d: "M43.709,360.226c1.6,5.084,3.256,10.079,3.9,15.369-.122.27-.024,1.231.113.958.094.853,1.384.6,1.323-.242-.054-.549-.107-1.1-.174-1.63,2.766-4,7.01-6.717,10.34-10.262a20.688,20.688,0,0,0,5.341-10.063c2.215-10.425-1.356-21.037,1.461-31.479,2.427-9,7.378-17.039,11.457-25.334,4.3-8.772,7.287-17.876,6.927-27.755-.263-7.564-1.9-17.551-8.062-22.78-6.531-5.551-13.752-.5-18.027,5.187C45.919,268.7,41.1,288.769,40.041,309c-.582,11.2-1.211,22.47-.055,33.647a90.422,90.422,0,0,0,3.723,17.575",
    transform: "translate(164.759 54.304)",
    fill: "#afbacf",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    "data-name": "Path 3841",
    d: "M47.17,375.1a191.54,191.54,0,0,1-1.934-31.464c-.02-.037-.055-.06-.06-.11-.794-8.485-2.09-16.9-2.38-25.432A151.7,151.7,0,0,1,44.534,290.5c.016-.106.179-.094.167.014a178.652,178.652,0,0,0-1,26.933q.27,7.218,1.172,14.393c.2,1.555.457,3.117.676,4.684v-.015A168.559,168.559,0,0,1,65.933,267.75c.157-.289.668-.03.516.266A175.2,175.2,0,0,0,49.5,319.131c5.62-12.522,14.716-23.147,21.154-35.256.035-.066.145-.008.116.06-5.6,13.365-15.672,24.32-21.635,37.52-.817,5.262-1.413,10.556-1.756,15.866a175.618,175.618,0,0,0,.026,21.858c3.416-7.693,7.01-15.074,9.676-23.141.072-.215.381-.093.326.119-2.161,8.334-5.223,17.366-9.9,24.682.349,5.148.879,10.287,1.56,15.406,1.816,13.665,5.153,27.035,7.24,40.636a.317.317,0,0,1-.622.114,315.34,315.34,0,0,1-8.518-41.9",
    transform: "translate(165.427 58.264)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3842",
    "data-name": "Path 3842",
    d: "M52.871,268.1c.035-.1.186-.046.157.058-2,7.115-2.9,14.242-4.191,21.482a.263.263,0,0,1-.524-.047c.209-7.264,2.256-14.643,4.558-21.493",
    transform: "translate(166.511 59.048)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    "data-name": "Path 3843",
    d: "M.95,297.576A104.6,104.6,0,0,0,7.586,309c5.116,7.867,10.377,15.032,11.929,24.515.694,4.234,1.144,8.507,2.744,12.517a38.053,38.053,0,0,0,5.769,9.533c5.417,6.769,11.984,12.461,17.061,19.524a87.23,87.23,0,0,1,12.154,24.142c.147.471.895.288.747-.184a.386.386,0,0,1-.037-.106.161.161,0,0,0,.037-.1c-.782-20.519-3.928-41.027-11.611-60.176a210.577,210.577,0,0,0-11.772-24.522c-3.867-6.864-8.538-13.395-14.8-18.275-4.06-3.152-12.8-9.049-17.974-5.21C-.649,292.5-.263,295.1.95,297.576",
    transform: "translate(157.809 64.364)",
    fill: "#afbacf",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    "data-name": "Path 3844",
    d: "M21.942,339.706a168.092,168.092,0,0,0,13.151,16.225c2.172,2.442,4.37,4.86,6.539,7.306,1.024,1.156,2.161,2.3,3.117,3.549-.7-2.112-1.384-4.229-2.091-6.339-3.4-10.147-6.7-20.392-11.368-30.048-4.558-9.436-10.343-18.189-16.258-26.816-.155-.228.216-.427.372-.208,4.847,6.8,9.759,13.577,13.946,20.807a114.806,114.806,0,0,1,6.188,12.5,198.856,198.856,0,0,0-9-27.016c-.032-.078.079-.145.12-.066A94.446,94.446,0,0,1,36,337.7a.1.1,0,0,1-.011.048q1.622,3.89,3.054,7.864c4.064,11.214,7.745,22.577,11.222,34a124.238,124.238,0,0,0-3.644-22.615c-.046-.171.211-.231.264-.066a72.339,72.339,0,0,1,3.738,23.849Q52.6,387.29,54.5,393.821c2.705,9.286,5.882,18.708,7.76,28.2a.192.192,0,0,1-.373.092c-1.783-5.06-3.023-10.352-4.556-15.5q-2.3-7.74-4.711-15.448c-2.336-7.484-4.756-14.942-7.209-22.39-1.473-2.689-4.1-4.977-6.112-7.176-2.2-2.412-4.407-4.825-6.559-7.283A115.455,115.455,0,0,1,21.767,339.8c-.07-.11.1-.2.175-.1",
    transform: "translate(160.476 65.354)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    "data-name": "Path 3845",
    d: "M19.557,326.421a107.031,107.031,0,0,1,13,17.641c.047.08-.076.178-.134.1-4.368-5.852-8.675-11.755-13.036-17.612-.074-.1.09-.218.171-.129",
    transform: "translate(164.078 70.427)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3846",
    "data-name": "Path 3846",
    d: "M98.911,309.7c-2.318,4.763-4.944,10.471-3.4,15.873.977,3.418,3.725,6.051,4.443,9.559,1.6,7.743-5.812,13.48-11.18,17.587-13.381,10.251-32.058,19.885-33.232,38.9-.049.674-1.214.591-1.179-.067a.389.389,0,0,1,.019-.127c-.031-.04-.073-.05-.078-.107a72.308,72.308,0,0,1-1.845-28.778c1.385-9.86,4.982-18.891,9.357-27.785,7.4-15.048,15.277-30.48,27.259-42.472,3.318-3.315,10.165-9.346,13.492-2.651,3.228,6.507-.812,14.258-3.654,20.065",
    transform: "translate(166.912 62.499)",
    fill: "#afbacf",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    "data-name": "Path 3847",
    d: "M88.017,335.4c-8.58,10.77-22.983,17.512-30.176,29.4,3.483-17.666,10.21-33.815,21.312-48.228a.364.364,0,0,0-.552-.476,91.764,91.764,0,0,0-18.053,30.726,131.081,131.081,0,0,1,7.067-22.875c.113-.283-.293-.49-.429-.211a84.976,84.976,0,0,0-7.543,25.684c-8.694,26.359-7.473,56.437-3.28,83.242.06.381.649.35.608-.044-2.166-21.208-3.408-42.855.164-63.982.074-.441.161-.878.24-1.316,7.835-12.8,22.175-19.522,30.814-31.768.084-.118-.079-.266-.173-.149",
    transform: "translate(167.229 67.879)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    "data-name": "Path 3848",
    d: "M85.761,324.83c-4.564,4.846-9.043,9.789-13.615,14.633-.047.048.025.131.079.087A71.694,71.694,0,0,0,86.074,325.1a.207.207,0,0,0-.313-.27",
    transform: "translate(170.67 70.116)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    "data-name": "Path 3849",
    d: "M85.141,308.566a153.939,153.939,0,0,1-13.162,21.2.087.087,0,0,0,.132.114,71.064,71.064,0,0,0,13.3-21.182.152.152,0,0,0-.273-.134",
    transform: "translate(170.644 66.931)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3850",
    "data-name": "Path 3850",
    d: "M79.662,445.309h-46.4l6.254-62.419h33Z",
    transform: "translate(163.687 81.186)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    "data-name": "Path 3851",
    d: "M72.81,393.036H37.62l1.018-10.146H71.65Z",
    transform: "translate(164.501 81.186)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3392",
    "data-name": "Rectangle 3392",
    width: 43.498,
    height: 9.966,
    transform: "translate(198.381 457.158)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M109.5,79.677a3.1,3.1,0,1,1-3.1-3.1,3.1,3.1,0,0,1,3.1,3.1",
    transform: "translate(187.686 -22.288)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3742",
    "data-name": "Path 3742",
    d: "M119.129,79.677a3.1,3.1,0,1,1-3.1-3.1,3.1,3.1,0,0,1,3.1,3.1",
    transform: "translate(190.482 -22.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3393",
    "data-name": "Rectangle 3393",
    width: 2.749,
    height: 18.805,
    transform: "translate(289.661 339.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    d: "M121.385,243.666v-5.434a.5.5,0,0,1,.506-.508.508.508,0,0,1,.516.508v2.211h2.386v-2.211a.5.5,0,0,1,.508-.508.509.509,0,0,1,.516.508v5.434a.508.508,0,0,1-.516.506.5.5,0,0,1-.508-.506v-2.211h-2.386v2.211a.507.507,0,0,1-.516.506.5.5,0,0,1-.506-.506",
    transform: "translate(192.952 27.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M123.541,262.339h-1.133v2a.511.511,0,0,1-1.022,0V258.9a.505.505,0,0,1,.506-.508h1.648a1.971,1.971,0,1,1,0,3.943m-1.133-1.022h1.133a.948.948,0,1,0,0-1.9h-1.133Z",
    transform: "translate(192.953 33.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M121.385,285.011v-5.434a.506.506,0,0,1,.506-.508.514.514,0,0,1,.516.508V284.5h2.5a.512.512,0,0,1,0,1.023h-3.012a.506.506,0,0,1-.506-.508",
    transform: "translate(192.954 39.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M124.767,304.668h-2.239l-.451,1.2a.516.516,0,0,1-.479.322.536.536,0,0,1-.175-.028.523.523,0,0,1-.3-.664l2.036-5.425a.515.515,0,0,1,.488-.322.507.507,0,0,1,.488.322l2.036,5.425a.523.523,0,0,1-.3.664.517.517,0,0,1-.646-.295Zm-.377-1.013-.746-1.98-.746,1.98Z",
    transform: "translate(192.861 46.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    d: "M710.909,96.058l-46.33.985-23.513.4c-7.857.166-15.754.131-23.633.194l-1.564.011-.007-1.585-.19-39.489-.007-1.772,1.768.011,46.739.222c15.577.018,31.155.4,46.736.575l.974.011-.01.953c-.067,6.7-.3,13.364-.462,19.953Zm0,0-.5-19.953c-.159-6.574-.4-13.075-.462-19.536l.964.963c-15.581.18-31.159.561-46.736.579l-46.739.222,1.765-1.765-.19,39.489-1.575-1.574c7.7.063,15.384.028,23.106.194l23.223.4Z",
    transform: "translate(-552.783 348.979)",
    fill: "#ebebeb",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    "data-name": "Path 4034",
    d: "M710.909,96.058l-46.33.985-23.513.4c-7.857.166-15.754.131-23.633.194l-1.564.011-.007-1.585-.19-39.489-.007-1.772,1.768.011,46.739.222c15.577.018,31.155.4,46.736.575l.974.011-.01.953c-.067,6.7-.3,13.364-.462,19.953Zm0,0-.5-19.953c-.159-6.574-.4-13.075-.462-19.536l.964.963c-15.581.18-31.159.561-46.736.579l-46.739.222,1.765-1.765-.19,39.489-1.575-1.574c7.7.063,15.384.028,23.106.194l23.223.4Z",
    transform: "translate(286.717 -0.026)",
    fill: "#ebebeb",
    opacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4822",
    "data-name": "Group 4822",
    transform: "translate(94 59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3492",
    "data-name": "Rectangle 3492",
    width: 1077,
    height: 605,
    transform: "translate(0)",
    fill: "none"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4593",
    "data-name": "Rectangle 4593",
    width: 1366,
    height: 769,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/MyProfile.77400f227191e92626a9a47649a723f9.svg";
export { ForwardRef as ReactComponent };